webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_auth__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_firestore__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_firestore__);




__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.initializeApp({
    apiKey: "AIzaSyCGQpN-5AO2TIbkOsOYrjErmJFHdIgfKyI",
    authDomain: "expense-tracker-demo-1.firebaseapp.com",
    databaseURL: "https://expense-tracker-demo-1.firebaseio.com",
    projectId: "expense-tracker-demo-1"
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Timestamp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(10);


var firestore = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].firestore();

firestore.settings({
    timestampsInSnapshots: true
});

firestore.enablePersistence();

var FieldValue = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].firestore.FieldValue;
var Timestamp = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].firestore.Timestamp;

/* harmony default export */ __webpack_exports__["c"] = (firestore);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notify_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141a9a9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notify_vue__ = __webpack_require__(166);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141a9a9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adae5e2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(170);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adae5e2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accounts__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__categories__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_mutations__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutations__ = __webpack_require__(63);


var _actions, _mutations;










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */],
        accounts: __WEBPACK_IMPORTED_MODULE_4__accounts__["a" /* default */],
        entries: __WEBPACK_IMPORTED_MODULE_5__entries__["a" /* default */],
        categories: __WEBPACK_IMPORTED_MODULE_6__categories__["a" /* default */]
    },

    strict: true,

    state: {
        language: 'en',
        currency: 'JPY'
    },

    getters: {
        language: function language(_ref) {
            var _language = _ref.language;
            return _language;
        },
        currency: function currency(_ref2) {
            var _currency = _ref2.currency;
            return _currency;
        }
    },

    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_8__mutations__["c" /* SET_LANGUAGE */], function (_ref3) {
        var commit = _ref3.commit,
            getters = _ref3.getters;

        commit(__WEBPACK_IMPORTED_MODULE_8__mutations__["c" /* SET_LANGUAGE */], getters['auth/preferences']);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_8__mutations__["b" /* SET_CURRENCY */], function (_ref4) {
        var commit = _ref4.commit,
            getters = _ref4.getters;

        commit(__WEBPACK_IMPORTED_MODULE_8__mutations__["b" /* SET_CURRENCY */], getters['auth/preferences']);
    }), _actions),

    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutations__["a" /* RESET */], function (state) {
        state = {};
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutations__["c" /* SET_LANGUAGE */], function (state, _ref5) {
        var language = _ref5.language;

        state.language = language;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutations__["b" /* SET_CURRENCY */], function (state, _ref6) {
        var _ref6$currency = _ref6.currency,
            currency = _ref6$currency === undefined ? 'JPY' : _ref6$currency;

        state.currency = currency;
    }), _mutations)
});

store.subscribeAction(function (_ref7) {
    var type = _ref7.type;

    if (type === 'auth/' + __WEBPACK_IMPORTED_MODULE_7__auth_mutations__["d" /* LOGOUT */]) {
        store.commit(__WEBPACK_IMPORTED_MODULE_8__mutations__["a" /* RESET */]);
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_PREFERENCES; });
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var LOGIN_REQUEST = 'LOGIN_REQUEST';
var LOGIN_RESULT = 'LOGIN_RESULT';
var SET_PREFERENCES = 'SET_PREFERENCES';
var UPDATE_PREFERENCES = 'UPDATE_PREFERENCES';

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppHeader_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppFooter_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutations__ = __webpack_require__(63);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AppHeader: __WEBPACK_IMPORTED_MODULE_4__components_AppHeader_vue__["a" /* default */],
        AppFooter: __WEBPACK_IMPORTED_MODULE_5__components_AppFooter_vue__["a" /* default */]
    },

    data: function data() {
        return {
            show: false
        };
    },

    watch: {
        loggedIn: function loggedIn(_loggedIn) {
            if (!_loggedIn) {
                this.$router.push({ name: 'Login' });
            }
        },
        preferences: function preferences(to, from) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!to.hasOwnProperty('language')) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__store_mutations__["c" /* SET_LANGUAGE */]);

                            case 3:
                                if (!to.hasOwnProperty('currency')) {
                                    _context.next = 6;
                                    break;
                                }

                                _context.next = 6;
                                return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__store_mutations__["b" /* SET_CURRENCY */]);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['loggedIn', 'preferences']))
});

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},

    data: function data() {
        return {
            menuOpen: false
        };
    },

    methods: {
        toggleMenu: function toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        openMenu: function openMenu() {
            this.menuOpen = true;
        },
        closeMenu: function closeMenu() {
            this.menuOpen = false;
        }
    }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CURRENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET; });
var SET_LANGUAGE = 'SET_LANGUAGE';
var SET_CURRENCY = 'SET_CURRENCY';
var RESET = 'RESET';

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accounts_vue__ = __webpack_require__(142);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Accounts: __WEBPACK_IMPORTED_MODULE_0__Accounts_vue__["a" /* default */]
    },

    data: function data() {
        return {};
    }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('accounts', ['accounts'])),

    watch: {
        accounts: function accounts(to, from) {
            var _this = this;

            if (to.length > 0) {
                to.forEach(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(account) {
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.next = 2;
                                        return _this.getEntryStream(account.id);

                                    case 2:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, _this);
                    }));

                    return function (_x) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    },

    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.getAccountStream();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },


    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('entries', ['getEntryStream']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('accounts', ['getAccountStream']))
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',

    watch: {
        loggedIn: function loggedIn(_loggedIn) {
            if (_loggedIn === true) {
                this.$router.back();
            }
        }
    },

    data: function data() {
        return {
            loginTexts: {
                en: 'Sign in with Google',
                'ja-JP': 'Googleログイン'
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['loggedIn']), {
        text: function text() {
            var lang = window.navigator.language;
            return this.loginTexts.hasOwnProperty(lang) ? this.loginTexts[lang] : this.loginTexts.en;
        },
        loginFlow: function loginFlow() {
            if ('standalone' in window.navigator) {
                return 'loginRequest';
            }

            return 'login';
        },
        withRedirect: function withRedirect() {
            return this.loginFlow === 'loginRequest';
        }
    }),

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!_this.withRedirect) {
                                _context.next = 9;
                                break;
                            }

                            _context.prev = 1;
                            _context.next = 4;
                            return _this.loginResult();

                        case 4:
                            _context.next = 9;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context['catch'](1);

                            console.log(_context.t0);

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 6]]);
        }))();
    },


    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('auth', {
        login: 'LOGIN',
        loginRequest: 'LOGIN_REQUEST',
        logout: 'LOGOUT'
    }), {
        signIn: function signIn() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2[_this2.loginFlow]();

                            case 2:
                                return _context2.abrupt('return', _context2.sent);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    })
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Auth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_firebase__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_auth_mutations__ = __webpack_require__(32);




/**
 * @typedef {Object} Auth
 * @property {firebase.auth.Auth} auth
 * @property {firebase.auth.AuthProvider} provider
 * @property {firebase.User|null} [user]
 */




var Auth = function () {
    /**
     * @param {FirebaseNamespace} firebase
     */
    function Auth(firebase) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Auth);

        this.auth = firebase.auth();
        this.provider = new firebase.auth.GoogleAuthProvider();
    }

    /**
     * @returns {firebase.auth.User}
     */


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Auth, [{
        key: 'login',


        /**
         * @returns {Promise.<firebase.auth.User>}
         */
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.auth.signInWithPopup(this.provider);

                            case 2:
                                return _context.abrupt('return', _context.sent);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function login() {
                return _ref.apply(this, arguments);
            }

            return login;
        }()

        /**
         * @returns {Promise.<void>}
         */

    }, {
        key: 'loginRequest',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.auth.signInWithRedirect(this.provider);

                            case 2:
                                return _context2.abrupt('return', _context2.sent);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function loginRequest() {
                return _ref2.apply(this, arguments);
            }

            return loginRequest;
        }()

        /**
         * @returns {Promise.<firebase.auth.User>}
         */

    }, {
        key: 'loginResult',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.auth.getRedirectResult();

                            case 2:
                                return _context3.abrupt('return', _context3.sent);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function loginResult() {
                return _ref3.apply(this, arguments);
            }

            return loginResult;
        }()

        /**
         * @returns {Promise.<void>}
         */

    }, {
        key: 'logout',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.auth.signOut();

                            case 2:
                                return _context4.abrupt('return', _context4.sent);

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function logout() {
                return _ref4.apply(this, arguments);
            }

            return logout;
        }()
    }, {
        key: 'user',
        get: function get() {
            return this.auth.currentUser;
        }
    }]);

    return Auth;
}();

__WEBPACK_IMPORTED_MODULE_4__app_firebase__["a" /* default */].auth().onAuthStateChanged(function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(user) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        if (!user) {
                            _context5.next = 6;
                            break;
                        }

                        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('auth/' + __WEBPACK_IMPORTED_MODULE_6__store_auth_mutations__["a" /* LOGIN */], user);
                        _context5.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('auth/' + __WEBPACK_IMPORTED_MODULE_6__store_auth_mutations__["e" /* SET_PREFERENCES */]);

                    case 4:
                        _context5.next = 8;
                        break;

                    case 6:
                        _context5.next = 8;
                        return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('auth/' + __WEBPACK_IMPORTED_MODULE_6__store_auth_mutations__["d" /* LOGOUT */]);

                    case 8:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function (_x) {
        return _ref5.apply(this, arguments);
    };
}());

/* harmony default export */ __webpack_exports__["a"] = (new Auth(__WEBPACK_IMPORTED_MODULE_4__app_firebase__["a" /* default */]));

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_auth_mutations__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Notify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_UserBox_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_currencies__ = __webpack_require__(173);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Notify: __WEBPACK_IMPORTED_MODULE_5__components_Notify__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_6__components_Loading_vue__["a" /* default */],
        UserBox: __WEBPACK_IMPORTED_MODULE_7__components_UserBox_vue__["a" /* default */]
    },

    data: function data() {
        return {
            updating: false,
            error: null,
            newPreferences: {
                language: 'en',
                currency: 'JPY',
                defaultAccount: null
            },
            currencies: __WEBPACK_IMPORTED_MODULE_8__helpers_currencies__["a" /* default */]
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['preferences', 'profile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('accounts', ['accounts'])),

    watch: {
        preferences: function preferences(to, from) {
            this.newPreferences = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to);
        }
    },

    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getAccountStream();

                        case 2:
                            _this.newPreferences = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.preferences);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', {
        updatePreferences: __WEBPACK_IMPORTED_MODULE_3__store_auth_mutations__["f" /* UPDATE_PREFERENCES */],
        logout: __WEBPACK_IMPORTED_MODULE_3__store_auth_mutations__["d" /* LOGOUT */]
    }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('accounts', ['getAccountStream']), {
        update: function update(preferences) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.updating = true;
                                _this2.error = null;

                                _context2.prev = 2;
                                _context2.next = 5;
                                return _this2.updatePreferences(preferences);

                            case 5:
                                _context2.next = 11;
                                break;

                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2['catch'](2);

                                console.log(_context2.t0);
                                _this2.error = _context2.t0;

                            case 11:
                                _context2.prev = 11;

                                _this2.updating = false;
                                return _context2.finish(11);

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 7, 11, 14]]);
            }))();
        }
    })
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: {
            type: String,
            default: 'info'
        },
        message: {
            type: String,
            required: true
        },
        retry: {
            type: Boolean,
            default: false
        },
        duration: {
            type: Number,
            default: 80000
        }
    },

    data: function data() {
        return {
            show: true
        };
    },

    computed: {
        title: function title() {
            if (this.type === 'error') return 'Error';

            return null;
        }
    },

    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.dismiss();
        }, this.duration);
    },


    methods: {
        dismiss: function dismiss() {
            this.show = false;
            this.$emit('dismiss');
        },
        retryAction: function retryAction() {
            this.$emit('retry');
            this.show = false;
        }
    }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading_LoadingAnimation_vue__ = __webpack_require__(167);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        busy: {}
    },

    components: {
        LoadingAnimation: __WEBPACK_IMPORTED_MODULE_0__Loading_LoadingAnimation_vue__["a" /* default */]
    },

    data: function data() {
        return {
            forceClose: false
        };
    },

    computed: {
        show: function show() {
            return this.busy && !this.forceClose;
        }
    },

    methods: {
        close: function close() {
            this.$emit('closed');
        }
    }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        profile: {
            type: Object,
            required: true
        },

        logout: {
            type: Function,
            required: true
        }
    }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Entries_Entries_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Entries_NewEntryScreen_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Notify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loading_vue__ = __webpack_require__(19);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Entries: __WEBPACK_IMPORTED_MODULE_5__Entries_Entries_vue__["a" /* default */],
        Notify: __WEBPACK_IMPORTED_MODULE_7__components_Notify__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_8__components_Loading_vue__["a" /* default */],
        NewEntryScreen: __WEBPACK_IMPORTED_MODULE_6__Entries_NewEntryScreen_vue__["a" /* default */]
    },

    data: function data() {
        return {
            showNewEntryScreen: false,
            removing: false,
            error: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('entries', ['entries']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('accounts', ['accounts']), {
        account: function account() {
            var _this = this;

            var filteredResult = this.accounts.filter(function (account) {
                return account.id === _this.$route.params.id;
            });

            return filteredResult.length > 0 ? filteredResult[0] : null;
        },
        hasEntries: function hasEntries() {
            return this.entries[this.account.name] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.entries[this.account.name]).length > 0;
        }
    }),

    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this2.getAccountStream();

                        case 2:
                            _context.next = 4;
                            return _this2.getEntryStream(_this2.$route.params.id);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this3.getAccountStream();

                        case 2:
                            _context2.next = 4;
                            return _this3.getEntryStream(to.params.id);

                        case 4:
                            next();

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this3);
        }))();
    },


    methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('entries', ['getEntryStream']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('accounts', ['getAccountStream', 'removeAccount']), {
        remove: function remove(account) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this4.removing = true;

                                _context3.prev = 1;
                                _context3.next = 4;
                                return _this4.removeAccount(account);

                            case 4:
                                _this4.removing = false;
                                _this4.$router.replace({ name: 'Home' });
                                _context3.next = 13;
                                break;

                            case 8:
                                _context3.prev = 8;
                                _context3.t0 = _context3['catch'](1);

                                console.log(_context3.t0);
                                _this4.error = _context3.t0;
                                _this4.removing = false;

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4, [[1, 8]]);
            }))();
        }
    })
});

/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_firestore__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EntriesOfTheDay_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        EntriesOfTheDay: __WEBPACK_IMPORTED_MODULE_8__EntriesOfTheDay_vue__["a" /* default */]
    },

    data: function data() {
        return {
            filteredBy: null,
            showDateSelectionMenu: false
        };
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getEntryStream(_this.$route.params.id);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.getEntryStream(to.params.id);

                        case 2:
                            next();

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },


    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])('entries', {
        allEntries: 'entries'
    }), {
        entries: function entries() {
            return this.allEntries[this.$route.params.id] !== undefined ? this.allEntries[this.$route.params.id] : {};
        },
        hasEntries: function hasEntries() {
            return this.entries && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.entries).length > 0;
        },
        availableDays: function availableDays() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.entries).sort().reverse();
        },
        availableMonths: function availableMonths() {
            if (!this.allEntries.hasOwnProperty(this.$route.params.id)) {
                return [];
            }

            return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["uniqBy"])(this.availableDays.map(function (date) {
                return new Date(__WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM'));
            }), function (date) {
                return date.getTime();
            });
        },
        title: function title() {
            if (this.filteredBy) {
                return __WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(this.filteredBy.toISOString()).toLocaleString({ year: 'numeric', month: 'long' });
            }
            return this.__('All entries');
        },
        filteredDays: function filteredDays() {
            if (this.filteredBy) {
                var filter = __WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(this.filteredBy.toISOString()).toFormat('yyyy-MM');
                return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["pickBy"])(this.availableDays, function (date) {
                    return new RegExp('^' + filter, 'g').test(date);
                });
            }

            return this.availableDays;
        },
        filteredEntries: function filteredEntries() {
            if (this.filteredBy) {
                var filter = __WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(this.filteredBy.toISOString()).toFormat('yyyy-MM');
                return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["pickBy"])(this.entries, function (_, date) {
                    return new RegExp('^' + filter, 'g').test(date);
                });
            }

            return this.entries;
        },
        remainingBalance: function remainingBalance() {
            return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["reduce"])([].concat.apply([], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.entries)), function (result, entry) {
                if (entry.type === 'income') {
                    return Number(result) + Number(entry.amount);
                }

                return Number(result) - Number(entry.amount);
            }, 0);
        }
    }),

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('entries', ['getEntryStream']), {
        filterWith: function filterWith() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.filteredBy = date;
            this.showDateSelectionMenu = false;
        }
    })
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Entry_vue__ = __webpack_require__(184);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        day: {},
        title: {
            required: false
        },
        entries: {}
    },

    components: {
        Entry: __WEBPACK_IMPORTED_MODULE_1__Entry_vue__["a" /* default */]
    },

    computed: {
        flow: function flow() {
            var entries = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["groupBy"])(this.entries, 'type');
            var expenses = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["sumBy"])(entries.expense, 'amount');
            var income = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["sumBy"])(entries.income, 'amount');

            return income - expenses;
        },
        hasTitle: function hasTitle() {
            return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.title);
        }
    },

    methods: {}
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},

    props: {
        entry: {
            type: Object,
            required: true
        }
    },

    data: function data() {
        return {
            editEntryModalOpen: false
        };
    },

    computed: {},

    methods: {}
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_firebase__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_firestore__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_luxon__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loading_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Notify_vue__ = __webpack_require__(18);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Notify: __WEBPACK_IMPORTED_MODULE_10__components_Notify_vue__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_9__components_Loading_vue__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
    },

    props: {
        account: {
            required: true
        }
    },

    data: function data() {
        return {
            form: {
                uid: null,
                type: 'expense',
                amount: null,
                enteredAt: new Date(),
                updatedAt: new Date(),
                category: null,
                description: null
            },
            newCategories: [],
            newDescriptions: [],
            selectedDate: __WEBPACK_IMPORTED_MODULE_8_luxon__["DateTime"].local().toISODate() + 'T' + __WEBPACK_IMPORTED_MODULE_8_luxon__["DateTime"].local().toFormat('HH:mm'),
            selectedCategory: null,
            selectedDescription: null,
            adding: false,
            error: null
        };
    },

    watch: {
        selectedDate: function selectedDate(newDate, old) {
            this.form.enteredAt = new Date(newDate);
        }
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getCategoryStream();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('categories', ['categories']), {
        allCategories: function allCategories() {
            return this.newCategories.concat(this.categories.map(function (category) {
                return category.name;
            }));
        },
        allDescriptions: function allDescriptions() {
            return this.descriptions.concat(this.newDescriptions);
        },
        descriptions: function descriptions() {
            var _this2 = this;

            var currentCategory = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(this.categories, function (category) {
                return category.name === _this2.selectedCategory;
            });

            if (currentCategory.length > 0) {
                return currentCategory[0].hasOwnProperty('descriptions') ? currentCategory[0].descriptions.map(function (description) {
                    return description.content;
                }) : [];
            }

            return [];
        }
    }),

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('entries', ['addEntry']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('categories', ['getCategoryStream']), {
        close: function close() {
            this.$emit('close');
        },
        add: function add(entry) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(entry.category)) {
                                    _context2.next = 3;
                                    break;
                                }

                                _this3.error = new Error('You cannot add an entry without a category.');
                                return _context2.abrupt('return');

                            case 3:

                                _this3.adding = true;

                                _context2.prev = 4;
                                _context2.next = 7;
                                return _this3.addEntry(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ accountId: _this3.account.name }, entry));

                            case 7:
                                _this3.close();
                                _context2.next = 13;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2['catch'](4);

                                console.log(_context2.t0);

                            case 13:
                                _context2.prev = 13;

                                _this3.adding = false;
                                return _context2.finish(13);

                            case 16:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[4, 10, 13, 16]]);
            }))();
        },
        addCategory: function addCategory(category) {
            this.newCategories.push(category);
            this.chooseCategory(category);
        },
        chooseCategory: function chooseCategory(category) {
            if (category) {
                this.selectedCategory = category;
                this.form.category = this.selectedCategory;
            }

            this.selectedDescription = null;
            this.form.description = null;
        },
        addDescription: function addDescription(description) {
            this.newDescriptions.push(description);
            this.chooseDescription(description);
        },
        chooseDescription: function chooseDescription(description) {
            if (description) {
                this.selectedDescription = description;
                this.form.description = this.selectedDescription;
            }
        }
    })

});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Notify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading_vue__ = __webpack_require__(19);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Notify: __WEBPACK_IMPORTED_MODULE_5__components_Notify__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_6__components_Loading_vue__["a" /* default */]
    },

    data: function data() {
        return {
            adding: false,
            error: null,
            types: ['cash', 'credit_card', 'debit_card', 'savings'],
            form: {
                name: null,
                type: 'cash'
            }
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('accounts', ['addAccount']), {
        add: function add(_ref) {
            var _this = this;

            var name = _ref.name,
                type = _ref.type;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(name)) {
                                    _context.next = 3;
                                    break;
                                }

                                _this.error = new Error('You cannot add an account without a name');
                                return _context.abrupt('return');

                            case 3:

                                _this.adding = true;
                                _this.error = null;

                                _context.prev = 5;
                                _context.next = 8;
                                return _this.addAccount({ name: name, type: type });

                            case 8:
                                _this.$router.push({ name: 'Home' });
                                _context.next = 15;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](5);

                                console.log(_context.t0);
                                _this.error = _context.t0;

                            case 15:
                                _context.prev = 15;

                                _this.adding = false;
                                return _context.finish(15);

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[5, 11, 15, 18]]);
            }))();
        }
    })
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_firebase__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_firestore__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_luxon__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loading_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Notify_vue__ = __webpack_require__(18);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Notify: __WEBPACK_IMPORTED_MODULE_10__components_Notify_vue__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_9__components_Loading_vue__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
    },

    data: function data() {
        return {
            form: {
                accountId: null,
                uid: null,
                type: 'expense',
                amount: null,
                enteredAt: new Date(),
                updatedAt: new Date(),
                category: null,
                description: null
            },
            newCategories: [],
            newDescriptions: [],
            selectedDate: __WEBPACK_IMPORTED_MODULE_8_luxon__["DateTime"].local().toISODate() + 'T' + __WEBPACK_IMPORTED_MODULE_8_luxon__["DateTime"].local().toFormat('HH:mm'),
            selectedCategory: null,
            selectedDescription: null,
            selectedAccount: null,
            busy: false,
            error: null,
            defaultAccountAlreadySetOnce: false
        };
    },

    watch: {
        selectedDate: function selectedDate(newDate, old) {
            this.form.enteredAt = new Date(newDate);
        },

        preferences: {
            immediate: true,
            handler: function handler(to, from) {
                if (to.defaultAccount) {
                    if (!this.defaultAccountAlreadySetOnce) {
                        var filteredResult = this.accounts.filter(function (account) {
                            return account.id === to.defaultAccount;
                        });
                        this.selectedAccount = filteredResult.length > 0 ? filteredResult[0] : null;
                        this.form.accountId = this.selectedAccount ? this.selectedAccount.name : null;
                        this.defaultAccountAlreadySetOnce = true;
                    }
                }
            }
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('auth', ['preferences']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('entries', ['entries']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('accounts', ['accounts']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('categories', ['categories']), {
        allCategories: function allCategories() {
            return this.newCategories.concat(this.categories.map(function (category) {
                return category.name;
            }));
        },
        allDescriptions: function allDescriptions() {
            return this.descriptions.concat(this.newDescriptions);
        },
        descriptions: function descriptions() {
            var _this = this;

            var currentCategory = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["filter"])(this.categories, function (category) {
                return category.name === _this.selectedCategory;
            });

            if (currentCategory.length > 0) {
                return currentCategory[0].hasOwnProperty('descriptions') ? currentCategory[0].descriptions.map(function (description) {
                    return description.content;
                }) : [];
            }

            return [];
        }
    }),

    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this2.getAccountStream();

                        case 2:
                            _context.next = 4;
                            return _this2.getCategoryStream();

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this3.getAccountStream();

                        case 2:
                            _context2.next = 4;
                            return _this3.getCategoryStream();

                        case 4:
                            next();

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this3);
        }))();
    },


    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('entries', ['addEntry']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('accounts', ['getAccountStream']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('categories', ['getCategoryStream']), {
        add: function add(entry) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(entry.category)) {
                                    _context3.next = 3;
                                    break;
                                }

                                _this4.error = new Error('You cannot add an entry without a category.');
                                return _context3.abrupt('return');

                            case 3:
                                if (!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(entry.accountId)) {
                                    _context3.next = 6;
                                    break;
                                }

                                _this4.error = new Error('You cannot add an entry without choosing an account.');
                                return _context3.abrupt('return');

                            case 6:

                                _this4.busy = true;

                                _context3.prev = 7;
                                _context3.next = 10;
                                return _this4.addEntry(entry);

                            case 10:
                                _this4.busy = false;
                                _this4.$router.push({ name: 'View Account', params: { id: _this4.form.accountId } });
                                _context3.next = 19;
                                break;

                            case 14:
                                _context3.prev = 14;
                                _context3.t0 = _context3['catch'](7);

                                console.log(_context3.t0);
                                _this4.error = _context3.t0;
                                _this4.busy = false;

                            case 19:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4, [[7, 14]]);
            }))();
        },
        addCategory: function addCategory(category) {
            this.newCategories.push(category);
            this.chooseCategory(category);
        },
        chooseCategory: function chooseCategory(category) {
            if (category) {
                this.selectedCategory = category;
                this.form.category = this.selectedCategory;
            }

            this.selectedDescription = null;
            this.form.description = null;
        },
        chooseAccount: function chooseAccount(account) {
            if (account) {
                this.selectedAccount = account;
                this.form.accountId = this.selectedAccount.name;
            }
        },
        addDescription: function addDescription(description) {
            this.newDescriptions.push(description);
            this.chooseDescription(description);
        },
        chooseDescription: function chooseDescription(description) {
            if (description) {
                this.selectedDescription = description;
                this.form.description = this.selectedDescription;
            }
        }
    })
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_firebase__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_firestore__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_luxon__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loading_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Notify_vue__ = __webpack_require__(18);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Notify: __WEBPACK_IMPORTED_MODULE_11__components_Notify_vue__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_10__components_Loading_vue__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a
    },

    data: function data() {
        return {
            entry: {},
            form: {
                accountId: '',
                uid: null,
                type: 'expense',
                amount: null,
                enteredAt: new Date(),
                updatedAt: new Date(),
                category: null,
                description: null
            },
            newCategories: [],
            newDescriptions: [],
            selectedDate: __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].local().toISODate() + 'T' + __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].local().toFormat('HH:mm'),
            selectedCategory: null,
            selectedDescription: null,
            selectedAccount: null,
            busy: false,
            error: null
        };
    },

    watch: {
        selectedDate: function selectedDate(newDate, old) {
            this.form.enteredAt = new Date(newDate);
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('entries', ['entries']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('accounts', ['accounts']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('categories', ['categories']), {
        account: function account() {
            var _this = this;

            var filteredResult = this.accounts.filter(function (account) {
                return account.id === _this.entry.accountId;
            });
            return filteredResult.length > 0 ? filteredResult[0] : null;
        },
        allCategories: function allCategories() {
            return this.newCategories.concat(this.categories.map(function (category) {
                return category.name;
            }));
        },
        allDescriptions: function allDescriptions() {
            return this.descriptions.concat(this.newDescriptions);
        },
        descriptions: function descriptions() {
            var _this2 = this;

            var currentCategory = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["filter"])(this.categories, function (category) {
                return category.name === _this2.selectedCategory;
            });

            if (currentCategory.length > 0) {
                return currentCategory[0].hasOwnProperty('descriptions') ? currentCategory[0].descriptions.map(function (description) {
                    return description.content;
                }) : [];
            }

            return [];
        }
    }),

    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var entry;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this3.getAccountStream();

                        case 2:
                            _context.next = 4;
                            return _this3.getCategoryStream();

                        case 4:
                            _context.next = 6;
                            return _this3.getEntry(_this3.$route.params.id);

                        case 6:
                            entry = _context.sent;


                            _this3.assignFormData(entry);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var entry;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this4.getAccountStream();

                        case 2:
                            _context2.next = 4;
                            return _this4.getCategoryStream();

                        case 4:
                            _context2.next = 6;
                            return _this4.getEntry(_this4.$route.params.id);

                        case 6:
                            entry = _context2.sent;


                            _this4.assignFormData(entry);
                            next();

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this4);
        }))();
    },


    methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('entries', ['updateEntry', 'removeEntry']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('accounts', ['getAccountStream']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('categories', ['getCategoryStream']), {
        assignFormData: function assignFormData(_ref) {
            var entry = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, []);

            var enteredAt = new __WEBPACK_IMPORTED_MODULE_6__app_firestore__["b" /* Timestamp */](entry.enteredAt.seconds, entry.enteredAt.nanoseconds).toDate();
            var date = __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].fromISO(enteredAt.toISOString());

            this.form.id = entry.id;
            this.form.uid = entry.uid;
            this.form.type = entry.type;
            this.form.amount = entry.amount;
            this.form.category = entry.category;
            this.form.description = entry.description;
            this.form.enteredAt = enteredAt;
            this.form.accountId = this.account.id;

            this.selectedAccount = this.account;
            this.selectedCategory = entry.category;
            this.selectedDescription = entry.description;
            this.selectedDate = date.toISODate() + 'T' + date.toFormat('HH:mm');
        },
        getEntry: function getEntry(entryId) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var entryRef, entryData;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                entryRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('entries').doc(entryId);
                                _context3.prev = 1;
                                _context3.next = 4;
                                return entryRef.get();

                            case 4:
                                entryData = _context3.sent;

                                _this5.entry = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: entryData.id }, entryData.data());
                                return _context3.abrupt('return', _this5.entry);

                            case 9:
                                _context3.prev = 9;
                                _context3.t0 = _context3['catch'](1);

                                console.log(_context3.t0);

                            case 12:
                                return _context3.abrupt('return', {});

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5, [[1, 9]]);
            }))();
        },
        update: function update(currentEntry, updatedEntry) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(updatedEntry.category)) {
                                    _context4.next = 3;
                                    break;
                                }

                                _this6.error = new Error('You cannot add an entry without a category.');
                                return _context4.abrupt('return');

                            case 3:

                                _this6.busy = true;

                                _context4.prev = 4;
                                _context4.next = 7;
                                return _this6.updateEntry({ currentEntry: currentEntry, updatedEntry: updatedEntry });

                            case 7:
                                _this6.busy = false;
                                _this6.$router.back();
                                _context4.next = 16;
                                break;

                            case 11:
                                _context4.prev = 11;
                                _context4.t0 = _context4['catch'](4);

                                console.log(_context4.t0);
                                _this6.error = _context4.t0;
                                _this6.busy = false;

                            case 16:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6, [[4, 11]]);
            }))();
        },
        remove: function remove(entry) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this7.busy = true;

                                _context5.prev = 1;
                                _context5.next = 4;
                                return _this7.removeEntry(entry);

                            case 4:
                                _this7.busy = false;
                                _this7.$router.back();
                                _context5.next = 13;
                                break;

                            case 8:
                                _context5.prev = 8;
                                _context5.t0 = _context5['catch'](1);

                                console.log(_context5.t0);
                                _this7.error = _context5.t0;
                                _this7.busy = false;

                            case 13:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7, [[1, 8]]);
            }))();
        },
        addCategory: function addCategory(category) {
            this.newCategories.push(category);
            this.chooseCategory(category);
        },
        chooseCategory: function chooseCategory(category) {
            if (category) {
                this.selectedCategory = category;
                this.form.category = this.selectedCategory;
            }

            this.selectedDescription = null;
            this.form.description = null;
        },
        chooseAccount: function chooseAccount(account) {
            if (account) {
                this.selectedAccount = account;
                this.form.accountId = this.selectedAccount.name;
            }
        },
        addDescription: function addDescription(description) {
            this.newDescriptions.push(description);
            this.chooseDescription(description);
        },
        chooseDescription: function chooseDescription(description) {
            if (description) {
                this.selectedDescription = description;
                this.form.description = this.selectedDescription;
            }
        }
    })
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('entries', ['entries']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('accounts', ['accounts']), {
        groupedEntries: function groupedEntries() {
            var entries = {};

            for (var accountId in this.allEntries) {
                var _groupBy = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["groupBy"])(this.allEntries[accountId], function (entry) {
                    return entry.type;
                }),
                    expenses = _groupBy.expense,
                    income = _groupBy.income;

                expenses = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapValues"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["groupBy"])(expenses, function (expense) {
                    return expense.category;
                }), function (entries) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(entries, function (result, entry) {
                        return Number(result) + Number(entry.amount);
                    }, 0);
                });

                income = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapValues"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["groupBy"])(income, function (inc) {
                    return inc.category;
                }), function (entries) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(entries, function (result, entry) {
                        return Number(result) + Number(entry.amount);
                    }, 0);
                });

                entries[accountId] = { expenses: expenses, income: income };
            }

            return entries;
        },
        totalIncome: function totalIncome() {
            var entries = {};

            for (var accountId in this.groupedEntries) {
                var income = this.groupedEntries[accountId].income;

                entries[accountId] = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(income, function (total, amount) {
                    return Number(total) + Number(amount);
                }, 0);
            }

            return entries;
        },
        allEntries: function allEntries() {
            return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapValues"])(this.entries, function (entries) {
                return [].concat.apply([], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(entries));
            });
        },
        totalExpense: function totalExpense() {
            var entries = {};

            for (var accountId in this.groupedEntries) {
                var expenses = this.groupedEntries[accountId].expenses;

                entries[accountId] = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(expenses, function (total, amount) {
                    return Number(total) + Number(amount);
                }, 0);
            }

            return entries;
        }
    }),

    watch: {
        accounts: function accounts(to, from) {
            var _this = this;

            if (to.length > 0) {
                to.forEach(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(account) {
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.next = 2;
                                        return _this.getEntryStream(account.id);

                                    case 2:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, _this);
                    }));

                    return function (_x) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    },

    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.getAccountStream();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },


    methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('entries', ['getEntryStream']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('accounts', ['getAccountStream']))
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getAccountStream();

                        case 2:
                            _context.next = 4;
                            return _this.getEntryStream(_this.$route.params.accountId);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        remainingType: function remainingType() {
            if (this.remainingBalance < 0) {
                return 'expense';
            }

            return 'income';
        },
        groupedEntries: function groupedEntries() {
            var _groupBy = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["groupBy"])(this.entries, function (entry) {
                return entry.type;
            }),
                expenses = _groupBy.expense,
                income = _groupBy.income;

            expenses = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapValues"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["groupBy"])(expenses, function (expense) {
                return expense.category;
            }), function (entries) {
                return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(entries, function (result, entry) {
                    return Number(result) + Number(entry.amount);
                }, 0);
            });

            income = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapValues"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["groupBy"])(income, function (inc) {
                return inc.category;
            }), function (entries) {
                return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(entries, function (result, entry) {
                    return Number(result) + Number(entry.amount);
                }, 0);
            });

            return { expenses: expenses, income: income };
        },
        totalIncome: function totalIncome() {
            var income = this.groupedEntries.income;

            return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(income, function (total, amount) {
                return Number(total) + Number(amount);
            }, 0);
        },
        account: function account() {
            var _this2 = this;

            var filteredResult = this.accounts.filter(function (account) {
                return account.id === _this2.$route.params.accountId;
            });

            return filteredResult.length > 0 ? filteredResult[0] : null;
        },
        totalExpense: function totalExpense() {
            var expenses = this.groupedEntries.expenses;

            return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["reduce"])(expenses, function (total, amount) {
                return Number(total) + Number(amount);
            }, 0);
        },
        remainingBalance: function remainingBalance() {
            return this.totalIncome - this.totalExpense;
        },
        entries: function entries() {
            var entries = this.allEntries[this.$route.params.accountId] !== undefined ? this.allEntries[this.$route.params.accountId] : {};

            return [].concat.apply([], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(entries));
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('entries', {
        allEntries: 'entries'
    }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('accounts', ['accounts'])),

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('entries', ['getEntryStream']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('accounts', ['getAccountStream']))
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portal_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_filters__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(209);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_portal_vue___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
    }
});

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b802a93_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b802a93_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f993a74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__(135);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f993a74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"relative h-16 px-4 shadow z-40 bg-white"},[_c('nav',{staticClass:"container mx-auto flex h-full justify-between items-center"},[_c('a',{staticClass:"font-thin text-grey hover:text-grey-dark block h-6 w-6 cursor-pointer",attrs:{"title":"Go Back"},on:{"click":function($event){$event.preventDefault();_vm.$router.back()}}},[_c('svg',{staticClass:"w-6 h-6 fill-current hover:text-grey-dark text-grey",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5.41 11H21a1 1 0 0 1 0 2H5.41l5.3 5.3a1 1 0 0 1-1.42 1.4l-7-7a1 1 0 0 1 0-1.4l7-7a1 1 0 0 1 1.42 1.4L5.4 11z"}})])]),_vm._v(" "),_c('router-link',{staticClass:"hidden sm:flex flex-1 justify-center",attrs:{"to":"/"}},[_c('img',{staticClass:"h-8",attrs:{"src":__webpack_require__(61),"alt":"Expense Tracker"}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center"},[(_vm.$route.name !== 'Home')?_c('a',{staticClass:"font-thin text-grey hover:text-grey-dark block h-6 w-6 cursor-pointer mr-4 sm:hidden",attrs:{"title":"Go Home"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({name: 'Home'})}}},[_c('svg',{staticClass:"w-6 h-6 fill-current hover:text-grey-dark text-grey",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M13 20v-5h-2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.59l-.3.3a1 1 0 1 1-1.4-1.42l9-9a1 1 0 0 1 1.4 0l9 9a1 1 0 0 1-1.4 1.42l-.3-.3V20a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm5 0v-9.59l-6-6-6 6V20h3v-5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v5h3z"}})])]):_c('div',{staticClass:"font-thin text-grey hover:text-grey-dark block h-6 w-6 mr-4 sm:hidden"},[_c('svg',{staticClass:"w-6 h-6 fill-current hover:text-grey-dark text-grey",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"m12 8.0036a4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4zm0 2a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z"}})])]),_vm._v(" "),_c('router-link',{staticClass:"block cursor-pointer flex items-center",attrs:{"to":"/settings"}},[_c('svg',{staticClass:"w-6 h-6 fill-current hover:text-grey-dark text-grey",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2z"}})])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24a722ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__(137);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24a722ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle_nav__wrapper"},[_c('button',{staticClass:"circle_nav__toggle",class:{'open': _vm.menuOpen },on:{"click":function($event){$event.preventDefault();return _vm.toggleMenu($event)}}},[(!_vm.menuOpen)?_c('svg',{staticClass:"circle_nav__toggle-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M4 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"}})]):_vm._e(),_vm._v(" "),(_vm.menuOpen)?_c('svg',{staticClass:"circle_nav__toggle-icon open",attrs:{"viewBox":"0 0 24 24","preserverAspectRatio":"true","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"circle_nav__links",class:{'open': _vm.menuOpen}},[_c('ul',[_c('router-link',{staticClass:"circle_nav__links-element",attrs:{"to":"/add","tag":"li"},nativeOn:{"click":function($event){return _vm.closeMenu($event)}}},[_c('a',{attrs:{"href":"#","title":_vm.__('Add Entry')}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-9h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2H9a1 1 0 0 1 0-2h2V9a1 1 0 0 1 2 0v2z"}})])])]),_vm._v(" "),_c('router-link',{staticClass:"circle_nav__links-element",attrs:{"to":"/","tag":"li"},nativeOn:{"click":function($event){return _vm.closeMenu($event)}}},[_c('a',{attrs:{"href":"#","title":_vm.__('Home')}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zM5.68 7.1A7.96 7.96 0 0 0 4.06 11H5a1 1 0 0 1 0 2h-.94a7.95 7.95 0 0 0 1.32 3.5A9.96 9.96 0 0 1 11 14.05V9a1 1 0 0 1 2 0v5.05a9.96 9.96 0 0 1 5.62 2.45 7.95 7.95 0 0 0 1.32-3.5H19a1 1 0 0 1 0-2h.94a7.96 7.96 0 0 0-1.62-3.9l-.66.66a1 1 0 1 1-1.42-1.42l.67-.66A7.96 7.96 0 0 0 13 4.06V5a1 1 0 0 1-2 0v-.94c-1.46.18-2.8.76-3.9 1.62l.66.66a1 1 0 0 1-1.42 1.42l-.66-.67zM6.71 18a7.97 7.97 0 0 0 10.58 0 7.97 7.97 0 0 0-10.58 0z"}})])])]),_vm._v(" "),_c('router-link',{staticClass:"circle_nav__links-element",attrs:{"to":"/overviews","tag":"li"},nativeOn:{"click":function($event){return _vm.closeMenu($event)}}},[_c('a',{attrs:{"href":"#","title":_vm.__('Overview')}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20 22H4a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h4V8c0-1.1.9-2 2-2h4V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM14 8h-4v12h4V8zm-6 4H4v8h4v-8zm8-8v16h4V4h-4z"}})])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (! _vm.$route.meta.hideAppLayout)?_c('div',[_c('AppHeader'),_vm._v(" "),_c('portal-target',{attrs:{"name":"notify"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"loading"}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('router-view')],1),_vm._v(" "),_c('AppFooter')],1):_c('div',{staticClass:"h-full"},[_c('main',{staticClass:"h-full"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Login__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Settings__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Account__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_NewAccount__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_NewEntry__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_EditEntry__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Overviews__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Overview__ = __webpack_require__(205);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkExactActiveClass: 'active',

    routes: [{
        path: '*',
        redirect: '/'
    }, {
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/add',
        name: 'Add Entry',
        component: __WEBPACK_IMPORTED_MODULE_8__pages_NewEntry__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/overviews',
        name: 'Overviews',
        component: __WEBPACK_IMPORTED_MODULE_10__pages_Overviews__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/overviews/:accountId',
        name: 'View Overview',
        component: __WEBPACK_IMPORTED_MODULE_11__pages_Overview__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/accounts/add',
        name: 'Add Account',
        component: __WEBPACK_IMPORTED_MODULE_7__pages_NewAccount__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/accounts/:id',
        name: 'View Account',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_Account__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/entries/:id/edit',
        name: 'Edit Entry',
        component: __WEBPACK_IMPORTED_MODULE_9__pages_EditEntry__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/settings',
        name: 'Settings',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_Settings__["a" /* default */],
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Login__["a" /* default */],
        meta: {
            hideAppLayout: true
        }
    }]
});

router.beforeEach(function (to, from, next) {
    var currentUser = __WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].user;
    var requiresAuth = to.matched.some(function (record) {
        return record.meta.requiresAuth;
    });

    if (requiresAuth && !currentUser) next('/login');else next();

    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0418e3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(144);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0418e3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accounts_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdc3d9b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__ = __webpack_require__(143);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdc3d9b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-start justify-start relative z-10"},[_c('section',{staticClass:"w-full p-4 relative z-10 shadow bg-white"},[_c('div',{staticClass:"container mx-auto flex justify-between items-center"},[_c('h2',{staticClass:"text-3xl font-hairline flex-1"},[_vm._v("\n                "+_vm._s(_vm.__('Accounts'))+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"block h-6 w-6 cursor-pointer",attrs:{"title":_vm.__('Add')},on:{"click":function($event){$event.preventDefault();_vm.$router.push({name: 'Add Account'})}}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey hover:text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-9h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2H9a1 1 0 0 1 0-2h2V9a1 1 0 0 1 2 0v2z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"container mx-auto"},[(_vm.accounts.length > 0)?_c('div',[_vm._l((_vm.accounts),function(account,idx){return [_c('div',{staticClass:"p-4 flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest pointer-events-auto cursor-pointer",on:{"click":function($event){_vm.$router.push({name: 'View Account', params: {id: account.id}})}}},[_c('img',{staticClass:"rounded-full h-16 w-16 border-2 border-grey-light mr-4",attrs:{"src":("/static/img/account-" + (account.type) + ".png")}}),_vm._v(" "),_c('div',{staticClass:"flex-1 flex flex-col justify-center items-start"},[_c('span',[_vm._v(_vm._s(account.name))]),_vm._v(" "),_c('span',{staticClass:"text-sm text-grey-dark"},[_vm._v(_vm._s(_vm.__(account.type)))])]),_vm._v(" "),_c('a',{staticClass:"block h-6 w-6 cursor-pointer",attrs:{"title":_vm.__('View Account')}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey hover:text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M9.3 8.7a1 1 0 0 1 1.4-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.29-3.3-3.3-3.3z"}})])])]),_vm._v(" "),(_vm.accounts.length - 1 !== idx)?_c('hr',{staticClass:"w-1/3 border-t-2"}):_vm._e()]})],2):_c('div',{staticClass:"p-4"},[_vm._v("\n            "+_vm._s(_vm.__('No accounts yet'))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Accounts')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_604f7eae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(147);
function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_604f7eae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-full w-full justify-center content-center items-center mt-8"},[_c('img',{staticClass:"h-12 my-8",attrs:{"src":__webpack_require__(61),"alt":"Expense Tracker"}}),_vm._v(" "),_c('a',{staticClass:"btn-google flex flex-row content-center items-center mb-8",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.signIn($event)}}},[_c('svg',{staticClass:"h-6 w-6",attrs:{"version":"1.1","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"transform":"translate(-14,-14)","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(-1,-1)"}},[_c('g',{attrs:{"transform":"translate(15,15)"}},[_c('path',{attrs:{"d":"m17.64 9.2045c0-0.63818-0.05727-1.2518-0.16364-1.8409h-8.4764v3.4814h4.8436c-0.20864 1.125-0.84273 2.0782-1.7959 2.7164v2.2582h2.9086c1.7018-1.5668 2.6836-3.8741 2.6836-6.615z","fill":"#4285f4"}}),_vm._v(" "),_c('path',{attrs:{"d":"m9 18c2.43 0 4.4673-0.80591 5.9564-2.1805l-2.9086-2.2582c-0.80591 0.54-1.8368 0.85909-3.0477 0.85909-2.3441 0-4.3282-1.5832-5.0359-3.7105h-3.0068v2.3318c1.4809 2.9414 4.5245 4.9582 8.0427 4.9582z","fill":"#34a853"}}),_vm._v(" "),_c('path',{attrs:{"d":"m3.9641 10.71c-0.18-0.54-0.28227-1.1168-0.28227-1.71s0.10227-1.17 0.28227-1.71v-2.3318h-3.0068c-0.60955 1.215-0.95727 2.5895-0.95727 4.0418 0 1.4523 0.34773 2.8268 0.95727 4.0418z","fill":"#fbbc05"}}),_vm._v(" "),_c('path',{attrs:{"d":"m9 3.5795c1.3214 0 2.5077 0.45409 3.4405 1.3459l2.5814-2.5814c-1.5586-1.4523-3.5959-2.3441-6.0218-2.3441-3.5182 0-6.5618 2.0168-8.0427 4.9582l3.0068 2.3318c0.70773-2.1273 2.6918-3.7105 5.0359-3.7105z","fill":"#ea4335"}}),_vm._v(" "),_c('path',{attrs:{"d":"m0 0h18v18h-18z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"flex-1 ml-4"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_firestore__ = __webpack_require__(11);





var _actions, _mutations;





var state = {
    loggedIn: false,
    profile: {},
    preferences: {}
};

var getters = {
    loggedIn: function loggedIn(_ref) {
        var _loggedIn = _ref.loggedIn;
        return _loggedIn;
    },
    profile: function profile(_ref2) {
        var _profile = _ref2.profile;
        return _profile;
    },
    preferences: function preferences(_ref3) {
        var _preferences = _ref3.preferences;
        return _preferences;
    }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__mutations__["b" /* LOGIN_REQUEST */], function () {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].loginRequest();

                    case 3:
                        _context.next = 8;
                        break;

                    case 5:
                        _context.prev = 5;
                        _context.t0 = _context['catch'](0);

                        console.log(_context.t0);

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 5]]);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__mutations__["c" /* LOGIN_RESULT */], function () {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].loginResult();

                    case 3:
                        result = _context2.sent;
                        _context2.next = 9;
                        break;

                    case 6:
                        _context2.prev = 6;
                        _context2.t0 = _context2['catch'](0);

                        console.log(_context2.t0);

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this2, [[0, 6]]);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* LOGIN */], function (_ref4) {
    var _this3 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref5, _user;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].login();

                    case 3:
                        _ref5 = _context3.sent;
                        _user = _ref5.user;


                        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* LOGIN */], _user);
                        _context3.next = 11;
                        break;

                    case 8:
                        _context3.prev = 8;
                        _context3.t0 = _context3['catch'](0);

                        console.log(_context3.t0);

                    case 11:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this3, [[0, 8]]);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__mutations__["d" /* LOGOUT */], function (_ref6) {
    var _this4 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].logout();

                    case 2:
                        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["d" /* LOGOUT */]);

                    case 3:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this4);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__mutations__["e" /* SET_PREFERENCES */], function (_ref7) {
    var _this5 = this;

    var commit = _ref7.commit,
        getters = _ref7.getters;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var userData, preferences;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].user.uid).get();

                    case 2:
                        userData = _context5.sent;
                        preferences = {
                            language: 'en',
                            currency: 'JPY'
                        };

                        if (userData.exists) {
                            _context5.next = 7;
                            break;
                        }

                        _context5.next = 7;
                        return user.ref.set(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getters.profile, {
                            preferences: preferences,
                            updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                        }));

                    case 7:

                        if (userData.exists && userData.data().hasOwnProperty('preferences')) {
                            preferences = userData.data().preferences;
                        }

                        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["e" /* SET_PREFERENCES */], { preferences: preferences });

                    case 9:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this5);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__mutations__["f" /* UPDATE_PREFERENCES */], function (_ref8, preferences) {
    var _this6 = this;

    var commit = _ref8.commit,
        getters = _ref8.getters;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var userRef;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].user.uid);

                    case 2:
                        userRef = _context6.sent;
                        _context6.next = 5;
                        return userRef.set(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getters.profile, {
                            preferences: preferences,
                            updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                        }), { merge: true });

                    case 5:

                        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["f" /* UPDATE_PREFERENCES */], { preferences: preferences });

                    case 6:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, _this6);
    }))();
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* LOGIN */], function (state, user) {
    state.loggedIn = true;

    state.profile = {
        uid: user.uid,
        name: user.displayName,
        email: user.email,
        picture: user.photoURL,
        phone: user.phoneNumber
    };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutations__["d" /* LOGOUT */], function (state) {
    state.loggedIn = false;
    state.profile = {};
    state.preferences = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutations__["e" /* SET_PREFERENCES */], function (state, _ref9) {
    var preferences = _ref9.preferences;

    state.preferences = preferences;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutations__["f" /* UPDATE_PREFERENCES */], function (state, _ref10) {
    var preferences = _ref10.preferences;

    state.preferences = preferences;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutations__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_firestore__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_firebase__ = __webpack_require__(10);







var _mutations;






var state = {
    accounts: [],
    accountStreamUnsubscriber: null
};

var getters = {
    accounts: function accounts(_ref) {
        var _accounts = _ref.accounts;
        return _accounts;
    }
};

var actions = {
    getAccountStream: function getAccountStream(_ref2) {
        var _this = this;

        var commit = _ref2.commit,
            state = _ref2.state;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var user, ref, accountStreamUnsubscriber;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_9__app_firebase__["a" /* default */].auth().currentUser;
                            ref = __WEBPACK_IMPORTED_MODULE_7__app_firestore__["c" /* default */].collection('users').doc(user.uid).collection('accounts').where('uid', '==', user.uid).orderBy('name', 'asc');

                            if (!state.accountStreamUnsubscriber) {
                                _context2.next = 4;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 4:
                            _context2.next = 6;
                            return ref.onSnapshot(function (snap) {
                                snap.docChanges().forEach(function () {
                                    var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(change) {
                                        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        if (change.type === 'added') {
                                                            commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["a" /* ADD_ACCOUNT */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data()));
                                                        }

                                                        if (change.type === 'modified') {
                                                            commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["d" /* UPDATE_ACCOUNT */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data()));
                                                        }

                                                        if (change.type === 'removed') {
                                                            commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["b" /* REMOVE_ACCOUNT */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data()));
                                                        }

                                                    case 3:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this);
                                    }));

                                    return function (_x) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }());
                            });

                        case 6:
                            accountStreamUnsubscriber = _context2.sent;


                            commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["c" /* SET_ACCOUNT_STREAM_UNSUBSCRIBER */], accountStreamUnsubscriber);

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }))();
    },
    addAccount: function addAccount(_ref4, _ref5) {
        var _this2 = this;

        var name = _ref5.name,
            type = _ref5.type;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var user, ref;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_9__app_firebase__["a" /* default */].auth().currentUser;
                            ref = __WEBPACK_IMPORTED_MODULE_7__app_firestore__["c" /* default */].collection('users').doc(user.uid).collection('accounts').doc(name);
                            _context3.prev = 2;
                            _context3.next = 5;
                            return ref.set({
                                name: name,
                                type: type,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_7__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            }, { merge: true });

                        case 5:
                            _context3.next = 10;
                            break;

                        case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3['catch'](2);
                            throw _context3.t0;

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2, [[2, 7]]);
        }))();
    },
    updateAccount: function updateAccount(_ref6, _ref7) {
        var _this3 = this;

        var currentAccount = _ref7.currentAccount,
            updatedAccount = _ref7.updatedAccount;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref6);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var user, currentRef, name, type, updatedRef, currentEntries;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_9__app_firebase__["a" /* default */].auth().currentUser;
                            currentRef = __WEBPACK_IMPORTED_MODULE_7__app_firestore__["c" /* default */].collection('users').doc(user.uid).collection('accounts').doc(currentAccount.name);
                            name = updatedAccount.name, type = updatedAccount.type;

                            if (!(currentAccount.name !== updatedAccount.name)) {
                                _context5.next = 15;
                                break;
                            }

                            updatedRef = __WEBPACK_IMPORTED_MODULE_7__app_firestore__["c" /* default */].collection('users').doc(user.uid).collection('accounts').doc(updatedAccount.name);
                            _context5.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_7__app_firestore__["c" /* default */].collection('entries').where('accountId', '==', name).where('uid', '==', user.uid).get();

                        case 7:
                            currentEntries = _context5.sent;
                            _context5.next = 10;
                            return updatedRef.set({
                                name: name,
                                type: type,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_7__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            });

                        case 10:
                            _context5.next = 12;
                            return currentEntries.docs.forEach(function () {
                                var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(entryDoc) {
                                    var _entryDoc$data, accountId, updatedAt, entry;

                                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    _entryDoc$data = entryDoc.data(), accountId = _entryDoc$data.accountId, updatedAt = _entryDoc$data.updatedAt, entry = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_entryDoc$data, ['accountId', 'updatedAt']);
                                                    _context4.next = 3;
                                                    return entryDoc.ref.set(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({ accountId: updatedAccount.name }, entry, { updatedAt: __WEBPACK_IMPORTED_MODULE_7__app_firestore__["a" /* FieldValue */].serverTimestamp() }), { merge: true });

                                                case 3:
                                                case 'end':
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this3);
                                }));

                                return function (_x2) {
                                    return _ref8.apply(this, arguments);
                                };
                            }());

                        case 12:
                            _context5.next = 14;
                            return currentRef.delete();

                        case 14:
                            return _context5.abrupt('return');

                        case 15:
                            _context5.next = 17;
                            return currentRef.update({
                                name: name,
                                type: type,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_7__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            });

                        case 17:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this3);
        }))();
    },
    removeAccount: function removeAccount(_ref9, _ref10) {
        var _this4 = this;

        var name = _ref10.name;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
            var user, ref, entriesRef, entries;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_9__app_firebase__["a" /* default */].auth().currentUser;
                            ref = __WEBPACK_IMPORTED_MODULE_7__app_firestore__["c" /* default */].collection('users').doc(user.uid).collection('accounts').doc(name);
                            entriesRef = __WEBPACK_IMPORTED_MODULE_7__app_firestore__["c" /* default */].collection('entries').where('accountId', '==', name).where('uid', '==', user.uid);
                            _context6.next = 5;
                            return entriesRef.get();

                        case 5:
                            entries = _context6.sent;

                            if (!entries.empty) {
                                _context6.next = 17;
                                break;
                            }

                            _context6.prev = 7;
                            _context6.next = 10;
                            return ref.delete();

                        case 10:
                            _context6.next = 15;
                            break;

                        case 12:
                            _context6.prev = 12;
                            _context6.t0 = _context6['catch'](7);
                            throw _context6.t0;

                        case 15:
                            _context6.next = 18;
                            break;

                        case 17:
                            throw new Error('You cannot remove an account with entries. Please remove all entries first.');

                        case 18:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this4, [[7, 12]]);
        }))();
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["c" /* SET_ACCOUNT_STREAM_UNSUBSCRIBER */], function (state, unsubscriber) {
    state.accountStreamUnsubscriber = unsubscriber;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["a" /* ADD_ACCOUNT */], function (state, account) {
    state.accounts.push(account);
    state.accounts = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["orderBy"])(state.accounts, function (a) {
        return a.name;
    }, ['asc']);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["d" /* UPDATE_ACCOUNT */], function (state, account) {
    var index = state.accounts.findIndex(function (a) {
        return a.id === account.id;
    });

    if (index === -1) {
        state.accounts.push(account);
    } else {
        state.accounts[index] = account;
    }

    state.accounts = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["orderBy"])(state.accounts, function (a) {
        return a.name;
    }, ['asc']);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["b" /* REMOVE_ACCOUNT */], function (state, account) {
    Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["remove"])(state.accounts, function (a) {
        return a.id === account.id;
    });

    state.accounts = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["orderBy"])(state.accounts, function (a) {
        return a.name;
    }, ['asc']);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ACCOUNT_STREAM_UNSUBSCRIBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_ACCOUNT; });
var SET_ACCOUNT_STREAM_UNSUBSCRIBER = 'SET_ACCOUNT_STREAM_UNSUBSCRIBER';
var ADD_ACCOUNT = 'ADD_ACCOUNT';
var UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
var REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';

/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_firestore__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_firebase__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_luxon__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(12);






var _mutations;








var state = {
    entries: {},
    entryStreamUnsubscribers: {}
};

var getters = {
    entries: function entries(_ref) {
        var _entries = _ref.entries;
        return _entries;
    }
};

var actions = {
    getEntryStream: function getEntryStream(_ref2, accountId) {
        var _this = this;

        var commit = _ref2.commit,
            state = _ref2.state;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var user, ref, entryStreamUnsubscriber;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            ref = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('entries').where('uid', '==', user.uid).where('accountId', '==', accountId).orderBy('enteredAt', 'desc');

                            if (!state.entryStreamUnsubscribers.hasOwnProperty(accountId)) {
                                _context2.next = 4;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 4:
                            _context2.next = 6;
                            return ref.onSnapshot(function (snap) {
                                snap.docChanges().forEach(function () {
                                    var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(change) {
                                        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        if (change.type === 'added') {
                                                            commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* ADD_ENTRY */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data()));
                                                        }

                                                        if (change.type === 'modified') {
                                                            commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["d" /* UPDATE_ENTRY */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data()));
                                                        }

                                                        if (change.type === 'removed') {
                                                            commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* REMOVE_ENTRY */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data()));
                                                        }

                                                    case 3:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this);
                                    }));

                                    return function (_x) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }());
                            });

                        case 6:
                            entryStreamUnsubscriber = _context2.sent;


                            commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* SET_ENTRY_STREAM_UNSUBSCRIBER */], { accountId: accountId, entryStreamUnsubscriber: entryStreamUnsubscriber });

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }))();
    },
    addEntry: function addEntry(_ref4, _ref5) {
        var _this2 = this;

        var accountId = _ref5.accountId,
            amount = _ref5.amount,
            category = _ref5.category,
            description = _ref5.description,
            enteredAt = _ref5.enteredAt,
            type = _ref5.type;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var user, entryRef, entry, batch, categoryId, categoryRef, descriptionRef;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            entryRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('entries').doc();
                            entry = {
                                uid: user.uid,
                                amount: Number(amount),
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp(),
                                type: type,
                                accountId: accountId,
                                category: category,
                                description: description,
                                enteredAt: enteredAt
                            };
                            batch = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].batch();

                            if (category) {
                                _context3.next = 6;
                                break;
                            }

                            throw new Error('You cannot add an entry without a category.');

                        case 6:
                            categoryId = user.uid + ':' + category;
                            categoryRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').doc(categoryId);


                            batch.set(categoryRef, {
                                name: category,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            }, { merge: true });

                            if (description) {
                                descriptionRef = categoryRef.collection('descriptions').doc(description);


                                batch.set(descriptionRef, {
                                    content: description,
                                    uid: user.uid,
                                    updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                                }, { merge: true });
                            }

                            batch.set(entryRef, entry, { merge: true });

                            _context3.prev = 11;
                            _context3.next = 14;
                            return batch.commit();

                        case 14:
                            _context3.next = 19;
                            break;

                        case 16:
                            _context3.prev = 16;
                            _context3.t0 = _context3['catch'](11);
                            throw _context3.t0;

                        case 19:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2, [[11, 16]]);
        }))();
    },
    updateEntry: function updateEntry(_ref6, _ref7) {
        var _this3 = this;

        var currentEntry = _ref7.currentEntry,
            updatedEntry = _ref7.updatedEntry;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref6);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var user, currentId, currentEnteredAt, currentRef, batch, category, description, categoryId, categoryRef, descriptionRef, entry, currentGroupId, updatedGroupId, updatedRef;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            currentId = currentEntry.id, currentEnteredAt = currentEntry.enteredAt;
                            currentRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('entries').doc(currentId);
                            batch = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].batch();
                            category = updatedEntry.category, description = updatedEntry.description;

                            if (category) {
                                _context4.next = 7;
                                break;
                            }

                            throw new Error('You cannot add an entry without a category.');

                        case 7:
                            categoryId = user.uid + ':' + category;
                            categoryRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').doc(categoryId);


                            batch.set(categoryRef, {
                                name: category,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            }, { merge: true });

                            if (description) {
                                descriptionRef = categoryRef.collection('descriptions').doc(description);


                                batch.set(descriptionRef, {
                                    content: description,
                                    uid: user.uid,
                                    updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                                }, { merge: true });
                            }

                            entry = {
                                uid: user.uid,
                                amount: Number(updatedEntry.amount),
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp(),
                                type: updatedEntry.type,
                                accountId: updatedEntry.accountId,
                                category: category,
                                description: description,
                                enteredAt: updatedEntry.enteredAt
                            };


                            if (currentEnteredAt.hasOwnProperty('seconds')) {
                                currentEnteredAt = new __WEBPACK_IMPORTED_MODULE_6__app_firestore__["b" /* Timestamp */](currentEnteredAt.seconds, currentEnteredAt.nanoseconds).toDate();
                            }

                            currentGroupId = __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].fromISO(currentEnteredAt.toISOString()).toISODate();
                            updatedGroupId = __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].fromISO(updatedEntry.enteredAt.toISOString()).toISODate();


                            if (currentGroupId !== updatedGroupId) {
                                updatedRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('entries').doc();


                                batch.set(updatedRef, entry, { merge: true });
                                batch.delete(currentRef);
                            } else {
                                batch.update(currentRef, entry);
                            }

                            _context4.prev = 16;
                            _context4.next = 19;
                            return batch.commit();

                        case 19:
                            _context4.next = 24;
                            break;

                        case 21:
                            _context4.prev = 21;
                            _context4.t0 = _context4['catch'](16);
                            throw _context4.t0;

                        case 24:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this3, [[16, 21]]);
        }))();
    },
    removeEntry: function removeEntry(_ref8, _ref9) {
        var _this4 = this;

        var id = _ref9.id,
            uid = _ref9.uid;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref8);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var user, ref;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;

                            if (!(user.uid !== uid)) {
                                _context5.next = 3;
                                break;
                            }

                            throw new Error('You cannot remove an entry of another user.');

                        case 3:
                            ref = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('entries').doc(id);
                            _context5.prev = 4;
                            _context5.next = 7;
                            return ref.delete();

                        case 7:
                            _context5.next = 12;
                            break;

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](4);
                            throw _context5.t0;

                        case 12:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4, [[4, 9]]);
        }))();
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* SET_ENTRY_STREAM_UNSUBSCRIBER */], function (state, _ref10) {
    var accountId = _ref10.accountId,
        entryStreamUnsubscriber = _ref10.entryStreamUnsubscriber;

    if (!state.entries.hasOwnProperty(accountId)) {
        state.entries = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, accountId, {}), state.entries);
    }

    state.entryStreamUnsubscribers[accountId] = entryStreamUnsubscriber;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* ADD_ENTRY */], function (state, entry) {
    if (!state.entries.hasOwnProperty(entry.accountId)) {
        state.entries = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, entry.accountId, {}), state.entries);
    }

    var enteredAt = new __WEBPACK_IMPORTED_MODULE_6__app_firestore__["b" /* Timestamp */](entry.enteredAt.seconds, entry.enteredAt.nanoseconds).toDate();
    var groupId = __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].fromISO(enteredAt.toISOString()).toISODate();

    if (!state.entries[entry.accountId].hasOwnProperty(groupId)) {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(state.entries[entry.accountId], groupId, []);
    }

    state.entries[entry.accountId][groupId].push(entry);

    state.entries[entry.accountId][groupId] = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(state.entries[entry.accountId][groupId], function (e) {
        return e.enteredAt.seconds;
    }, ['desc']);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["d" /* UPDATE_ENTRY */], function (state, entry) {
    /**
     * We will always delete an entry and create a new one if
     * enteredAt changed, so update will only ever be called when no dates
     * have changed.
     */
    if (!state.entries.hasOwnProperty(entry.accountId)) {
        state.entries = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, entry.accountId, {}), state.entries);
    }

    var enteredAt = new __WEBPACK_IMPORTED_MODULE_6__app_firestore__["b" /* Timestamp */](entry.enteredAt.seconds, entry.enteredAt.nanoseconds).toDate();
    var groupId = __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].fromISO(enteredAt.toISOString()).toISODate();

    if (!state.entries[entry.accountId].hasOwnProperty(groupId)) {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(state.entries[entry.accountId], groupId, []);
    }

    var index = state.entries[entry.accountId][groupId].findIndex(function (e) {
        return e.id === entry.id;
    });

    if (index === -1) {
        state.entries[entry.accountId][groupId].push(entry);
    } else {
        state.entries[entry.accountId][groupId][index] = entry;
    }

    state.entries[entry.accountId][groupId] = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(state.entries[entry.accountId][groupId], function (e) {
        return e.enteredAt.seconds;
    }, ['desc']);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* REMOVE_ENTRY */], function (state, entry) {
    if (!state.entries.hasOwnProperty(entry.accountId)) {
        state.entries = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, entry.accountId, {}), state.entries);
    }

    var enteredAt = new __WEBPACK_IMPORTED_MODULE_6__app_firestore__["b" /* Timestamp */](entry.enteredAt.seconds, entry.enteredAt.nanoseconds).toDate();
    var groupId = __WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].fromISO(enteredAt.toISOString()).toISODate();

    if (!state.entries[entry.accountId].hasOwnProperty(groupId)) {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(state.entries[entry.accountId], groupId, []);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["remove"])(state.entries[entry.accountId][groupId], function (e) {
        return e.id === entry.id;
    });

    if (state.entries[entry.accountId][groupId].length > 0) {
        state.entries[entry.accountId][groupId] = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(state.entries[entry.accountId][groupId], function (e) {
            return e.enteredAt.seconds;
        }, ['desc']);
    } else {
        delete state.entries[entry.accountId][groupId];
    }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ENTRY_STREAM_UNSUBSCRIBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_ENTRY; });
var SET_ENTRY_STREAM_UNSUBSCRIBER = 'SET_ENTRY_STREAM_UNSUBSCRIBER';
var ADD_ENTRY = 'ADD_ENTRY';
var UPDATE_ENTRY = 'UPDATE_ENTRY';
var REMOVE_ENTRY = 'REMOVE_ENTRY';

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_firestore__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_firebase__ = __webpack_require__(10);






var _mutations;






var state = {
    categories: [],
    categoryStreamUnsubscriber: null
};

var getters = {
    categories: function categories(_ref) {
        var _categories = _ref.categories;
        return _categories;
    }
};

var actions = {
    getCategoryStream: function getCategoryStream(_ref2) {
        var _this = this;

        var commit = _ref2.commit,
            state = _ref2.state;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var user, ref, categoryStreamUnsubscriber;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            ref = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').where('uid', '==', user.uid).orderBy('name', 'asc');

                            if (!state.categoryStreamUnsubscriber) {
                                _context3.next = 4;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 4:
                            _context3.next = 6;
                            return ref.onSnapshot(function () {
                                var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(snap) {
                                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    snap.docChanges().forEach(function () {
                                                        var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(change) {
                                                            var descriptionsRef, descriptions;
                                                            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                                                while (1) {
                                                                    switch (_context.prev = _context.next) {
                                                                        case 0:
                                                                            descriptionsRef = change.doc.ref.collection('descriptions').where('uid', '==', user.uid).orderBy('content', 'asc');
                                                                            _context.next = 3;
                                                                            return descriptionsRef.get();

                                                                        case 3:
                                                                            descriptions = _context.sent;


                                                                            if (!descriptions.empty) {
                                                                                descriptions = descriptions.docs.map(function (d) {
                                                                                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: d.id }, d.data());
                                                                                });
                                                                            } else {
                                                                                descriptions = [];
                                                                            }

                                                                            if (change.type === 'added') {
                                                                                commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* ADD_CATEGORY */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data(), { descriptions: descriptions }));
                                                                            }

                                                                            if (change.type === 'modified') {
                                                                                commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["d" /* UPDATE_CATEGORY */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data(), { descriptions: descriptions }));
                                                                            }

                                                                            if (change.type === 'removed') {
                                                                                commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* REMOVE_CATEGORY */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: change.doc.id }, change.doc.data(), { descriptions: descriptions }));
                                                                            }

                                                                        case 8:
                                                                        case 'end':
                                                                            return _context.stop();
                                                                    }
                                                                }
                                                            }, _callee, _this);
                                                        }));

                                                        return function (_x2) {
                                                            return _ref4.apply(this, arguments);
                                                        };
                                                    }());

                                                case 1:
                                                case 'end':
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, _this);
                                }));

                                return function (_x) {
                                    return _ref3.apply(this, arguments);
                                };
                            }());

                        case 6:
                            categoryStreamUnsubscriber = _context3.sent;


                            commit(__WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* SET_CATEGORY_STREAM_UNSUBSCRIBER */], categoryStreamUnsubscriber);

                        case 8:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }))();
    },
    addCategory: function addCategory(_ref5, _ref6) {
        var _this2 = this;

        var name = _ref6.name;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var user, doc, ref;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            doc = user.uid + ':' + name;
                            ref = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').doc(doc);
                            _context4.prev = 3;
                            _context4.next = 6;
                            return ref.set({
                                name: name,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            }, { merge: true });

                        case 6:
                            _context4.next = 11;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](3);
                            throw _context4.t0;

                        case 11:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this2, [[3, 8]]);
        }))();
    },
    addDescription: function addDescription(_ref7, _ref8) {
        var _this3 = this;

        var categoryId = _ref8.categoryId,
            description = _ref8.description;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var user, content, ref;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            content = description.content;
                            ref = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').doc(categoryId).collection('descriptions').doc(content);
                            _context5.prev = 3;
                            _context5.next = 6;
                            return ref.set({
                                content: content,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            }, { merge: true });

                        case 6:
                            _context5.next = 11;
                            break;

                        case 8:
                            _context5.prev = 8;
                            _context5.t0 = _context5['catch'](3);
                            throw _context5.t0;

                        case 11:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this3, [[3, 8]]);
        }))();
    },
    updateCategory: function updateCategory(_ref9, _ref10) {
        var _this4 = this;

        var currentCategory = _ref10.currentCategory,
            updatedCategory = _ref10.updatedCategory;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
            var user, currentDoc, currentRef, name, updatedDoc, updatedRef, currentDescriptions;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            currentDoc = user.uid + ':' + currentCategory.name;
                            currentRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').doc(currentDoc);
                            name = updatedCategory.name;

                            if (!(currentCategory.name !== updatedCategory.name)) {
                                _context7.next = 16;
                                break;
                            }

                            updatedDoc = user.uid + ':' + updatedCategory.name;
                            updatedRef = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').doc(updatedDoc);
                            _context7.next = 9;
                            return currentRef.collection('descriptions').where('uid', '==', user.uid).get();

                        case 9:
                            currentDescriptions = _context7.sent;
                            _context7.next = 12;
                            return updatedRef.set({
                                name: name,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            });

                        case 12:

                            currentDescriptions.docs.forEach(function () {
                                var _ref11 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(description) {
                                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                                        while (1) {
                                            switch (_context6.prev = _context6.next) {
                                                case 0:
                                                    _context6.next = 2;
                                                    return updatedRef.collection('descriptions').doc(description.id).set(description.data());

                                                case 2:
                                                    _context6.next = 4;
                                                    return currentRef.collection('descriptions').doc(description.id).delete();

                                                case 4:
                                                case 'end':
                                                    return _context6.stop();
                                            }
                                        }
                                    }, _callee6, _this4);
                                }));

                                return function (_x3) {
                                    return _ref11.apply(this, arguments);
                                };
                            }());

                            _context7.next = 15;
                            return currentRef.delete();

                        case 15:
                            return _context7.abrupt('return');

                        case 16:
                            _context7.next = 18;
                            return currentRef.update({
                                name: name,
                                uid: user.uid,
                                updatedAt: __WEBPACK_IMPORTED_MODULE_6__app_firestore__["a" /* FieldValue */].serverTimestamp()
                            });

                        case 18:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this4);
        }))();
    },
    removeCategory: function removeCategory(_ref12, _ref13) {
        var _this5 = this;

        var id = _ref13.id,
            uid = _ref13.uid,
            category = _ref13.category;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref12);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
            var user, doc, ref;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            user = __WEBPACK_IMPORTED_MODULE_8__app_firebase__["a" /* default */].auth().currentUser;
                            doc = user.uid + ':' + category.name;
                            ref = __WEBPACK_IMPORTED_MODULE_6__app_firestore__["c" /* default */].collection('categories').doc(doc);
                            _context8.prev = 3;
                            _context8.next = 6;
                            return ref.delete();

                        case 6:
                            _context8.next = 11;
                            break;

                        case 8:
                            _context8.prev = 8;
                            _context8.t0 = _context8['catch'](3);
                            throw _context8.t0;

                        case 11:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this5, [[3, 8]]);
        }))();
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* SET_CATEGORY_STREAM_UNSUBSCRIBER */], function (state, unsubscriber) {
    state.categoryStreamUnsubscriber = unsubscriber;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* ADD_CATEGORY */], function (state, category) {
    state.categories.push(category);
    state.categories = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(state.categories, function (c) {
        return c.name;
    }, ['asc']);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["d" /* UPDATE_CATEGORY */], function (state, category) {
    var index = state.categories.findIndex(function (c) {
        return c.id === category.id;
    });

    if (index === -1) {
        state.categories.push(category);
    } else {
        state.categories[index] = category;
    }

    state.categories = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(state.categories, function (c) {
        return c.name;
    }, ['asc']);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* REMOVE_CATEGORY */], function (state, category) {
    Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["remove"])(state.categories, function (c) {
        return c.id === category.id;
    });

    state.categories = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(state.categories, function (c) {
        return c.name;
    }, ['asc']);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CATEGORY_STREAM_UNSUBSCRIBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_CATEGORY; });
var SET_CATEGORY_STREAM_UNSUBSCRIBER = 'SET_CATEGORY_STREAM_UNSUBSCRIBER';
var ADD_CATEGORY = 'ADD_CATEGORY';
var UPDATE_CATEGORY = 'UPDATE_CATEGORY';
var REMOVE_CATEGORY = 'REMOVE_CATEGORY';

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38132032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(174);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38132032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"notify"}},[_c('transition',{attrs:{"name":"fadeInDown"}},[(_vm.show)?_c('section',{staticClass:"bg-white relative z-30 bg-grey-lightest flex justify-center items-center shadow"},[_c('div',{staticClass:"flex flex justify-start items-center bg-white w-full sm:shadow-md p-4"},[_c('div',{staticClass:"flex flex-col flex-1 justify-start items-start"},[(_vm.title)?_c('h3',{staticClass:"text-lg font-thin pb-2"},[_vm._v(_vm._s(_vm.__(_vm.title)))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"block text-sm"},[_vm._v(_vm._s(_vm.__(_vm.message)))])]),_vm._v(" "),(_vm.retry)?_c('button',{staticClass:"flex bg-grey-lighter p-2 mr-4",attrs:{"title":_vm.__('Retry')},on:{"click":function($event){_vm.retryAction()}}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5.41 16H18a2 2 0 0 0 2-2 1 1 0 0 1 2 0 4 4 0 0 1-4 4H5.41l2.3 2.3a1 1 0 0 1-1.42 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 1 1 1.42 1.4L5.4 16zM6 8a2 2 0 0 0-2 2 1 1 0 0 1-2 0 4 4 0 0 1 4-4h12.59l-2.3-2.3a1 1 0 1 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4L18.6 8H6z"}})])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"bg-grey-lighter p-2",attrs:{"title":_vm.__('Dismiss')},on:{"click":function($event){_vm.show = false}}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16.24 14.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 0 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12l2.83 2.83z"}})])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae4d4f74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingAnimation_vue__ = __webpack_require__(169);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae4d4f74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingAnimation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"loading"}},[_c('transition',{attrs:{"name":"fadeInDown"}},[(_vm.show)?_c('div',{staticClass:"relative z-20 flex justify-center items-center bg-white w-full p-4 pb-3 shadow"},[_c('div',{staticClass:"flex justify-center items-center h-full w-full"},[_c('LoadingAnimation')],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e16624c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBox_vue__ = __webpack_require__(172);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e16624c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto bg-white flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest"},[_c('img',{staticClass:"rounded-full h-12 w-12 border-2 p-0.5 border-grey-light mr-4",attrs:{"src":_vm.profile.picture}}),_vm._v(" "),_c('div',{staticClass:"flex-1 flex flex-col justify-center items-start"},[_c('span',[_vm._v(_vm._s(_vm.profile.name))]),_vm._v(" "),_c('span',{staticClass:"text-sm text-grey-dark"},[_vm._v(_vm._s(_vm.profile.email))])]),_vm._v(" "),_c('a',{staticClass:"block h-6 w-6 cursor-pointer",attrs:{"title":_vm.__('Logout')},on:{"click":_vm.logout}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey hover:text-grey-dark",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M12,3L12,3c-0.55,0-1,0.45-1,1v8c0,0.55,0.45,1,1,1h0c0.55,0,1-0.45,1-1V4C13,3.45,12.55,3,12,3z M17.14,5.86L17.14,5.86\n            c-0.39,0.39-0.38,1-0.01,1.39c1.13,1.2,1.83,2.8,1.87,4.57c0.09,3.83-3.08,7.13-6.91,7.17C8.18,19.05,5,15.9,5,12\n            c0-1.84,0.71-3.51,1.87-4.76c0.37-0.39,0.37-1-0.01-1.38l0,0c-0.4-0.4-1.05-0.39-1.43,0.02C3.98,7.42,3.07,9.47,3,11.74\n            c-0.14,4.88,3.83,9.1,8.71,9.25c5.1,0.16,9.29-3.93,9.29-9c0-2.37-0.92-4.51-2.42-6.11C18.2,5.47,17.54,5.46,17.14,5.86z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'JPY': {
        'symbol': '¥',
        'name': 'Japanese Yen',
        'symbol_native': '￥',
        'decimal_digits': 0,
        'rounding': 0,
        'code': 'JPY',
        'name_plural': 'Japanese yen'
    },
    'EUR': {
        'symbol': '€',
        'name': 'Euro',
        'symbol_native': '€',
        'decimal_digits': 2,
        'rounding': 0,
        'code': 'EUR',
        'name_plural': 'euros'
    },
    'USD': {
        'symbol': '$',
        'name': 'US Dollar',
        'symbol_native': '$',
        'decimal_digits': 2,
        'rounding': 0,
        'code': 'USD',
        'name_plural': 'US dollars'
    },
    'CAD': {
        'symbol': 'CA$',
        'name': 'Canadian Dollar',
        'symbol_native': '$',
        'decimal_digits': 2,
        'rounding': 0,
        'code': 'CAD',
        'name_plural': 'Canadian dollars'
    },
    'TRY': {
        'symbol': 'TL',
        'name': 'Turkish Lira',
        'symbol_native': 'TL',
        'decimal_digits': 2,
        'rounding': 0,
        'code': 'TRY',
        'name_plural': 'Turkish Lira'
    }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-start justify-start"},[_c('section',{staticClass:"bg-white w-full p-4 relative z-10 shadow"},[_c('UserBox',{attrs:{"profile":_vm.profile,"logout":_vm.logout}})],1),_vm._v(" "),_c('div',{staticClass:"container mx-auto"},[_c('h2',{staticClass:"text-3xl font-hairline flex-1 flex items-center p-4"},[_vm._v("\n            "+_vm._s(_vm.__('Settings'))+"\n        ")]),_vm._v(" "),_c('form',{staticClass:"w-full p-6 flex flex-col justify-start items-center",on:{"submit":function($event){$event.preventDefault();_vm.update(_vm.newPreferences)}}},[_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-language"}},[_vm._v("\n                        "+_vm._s(_vm.__('Language'))+"\n                    ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPreferences.language),expression:"newPreferences.language"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"id":"grid-language"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newPreferences, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"en"}},[_vm._v(_vm._s(_vm.__('English')))]),_vm._v(" "),_c('option',{attrs:{"value":"ja"}},[_vm._v(_vm._s(_vm.__('Japanese')))])])]),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-6 pt-3 text-grey-darker"},[_c('svg',{staticClass:"fill-current h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"}})])])]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-account"}},[_vm._v("\n                        "+_vm._s(_vm.__('Currency'))+"\n                    ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPreferences.currency),expression:"newPreferences.currency"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"id":"grid-account"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newPreferences, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.currencies),function(currency,code){return _c('option',{domProps:{"value":code}},[_vm._v(_vm._s(currency.code)+" - "+_vm._s(currency.name))])}))]),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-6 pt-3 text-grey-darker"},[_c('svg',{staticClass:"fill-current h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"}})])])]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-account"}},[_vm._v("\n                        "+_vm._s(_vm.__('Default Account'))+"\n                    ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPreferences.defaultAccount),expression:"newPreferences.defaultAccount"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"id":"grid-account"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newPreferences, "defaultAccount", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.accounts),function(account){return _c('option',{domProps:{"value":account.name}},[_vm._v(_vm._s(account.name))])}))]),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-6 pt-3 text-grey-darker"},[_c('svg',{staticClass:"fill-current h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"}})])])]),_vm._v(" "),_c('hr',{staticClass:"w-1/3 border-t mb-3"}),_vm._v(" "),_c('button',{staticClass:"w-1/2 bg-expense text-white p-3",attrs:{"type":"submit","disabled":_vm.updating}},[_vm._v("\n                "+_vm._s(_vm.__('Save'))+"\n            ")])])]),_vm._v(" "),(_vm.error)?_c('Notify',{attrs:{"type":"error","message":_vm.error.message,"show":_vm.error,"retry":true},on:{"retry":function($event){_vm.update(_vm.newPreferences)}}}):_vm._e(),_vm._v(" "),_c('Loading',{attrs:{"busy":_vm.updating}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8f6e34a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__(192);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8f6e34a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entries_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36060ea2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entries_vue__ = __webpack_require__(187);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36060ea2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntriesOfTheDay_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16cdc382_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntriesOfTheDay_vue__ = __webpack_require__(186);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntriesOfTheDay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16cdc382_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntriesOfTheDay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entry_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563a6418_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entry_vue__ = __webpack_require__(185);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563a6418_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center"},[_c('div',{staticClass:"bg-o5-grey-lighter block border-b border-o5-grey-light flex flex-col justify-center p-4 w-full",on:{"click":function($event){_vm.$router.push({name: 'Edit Entry', params: {id: _vm.entry.id}})}}},[_c('div',{staticClass:"flex flex-row items-center relative"},[_c('div',{staticClass:"flex-1"},[_c('div',{class:{'pb-2': _vm.entry.description}},[_vm._v(_vm._s(_vm.entry.category))]),_vm._v(" "),(_vm.entry.description)?_c('div',{staticClass:"text-grey text-sm"},[_vm._v(_vm._s(_vm.entry.description))]):_vm._e()]),_vm._v(" "),_c('h5',{staticClass:"text-2xl font-light",class:{'text-expense': _vm.entry.type === 'expense', 'text-income': _vm.entry.type === 'income'}},[_vm._v("\n                "+_vm._s(_vm.entry.type === 'expense' ? '- ' : '')+_vm._s(_vm._f("yen")(_vm.entry.amount))+"\n            ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"flex flex-row justify-between w-full"},[(_vm.hasTitle)?_c('span',{staticClass:"font-thin text-sm pb-2 px-4 block mt-4"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(! _vm.hasTitle)?_c('span',{staticClass:"font-thin text-sm pb-2 px-4 block mt-4"},[_vm._v(_vm._s(_vm._f("date")(_vm.day)))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"font-thin text-sm pb-2 px-4 block mt-4"},[_vm._v(_vm._s(_vm._f("yen")(_vm.flow)))])]),_vm._v(" "),_c('div',{staticClass:"entries"},_vm._l((_vm.entries),function(entry){return _c('Entry',{key:entry.id,attrs:{"entry":entry}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto"},[(_vm.hasEntries)?_c('div',{staticClass:"w-full overflow-hidden mb-8"},[_c('div',{staticClass:"flex flex-row justify-between mx-4 mt-4"},[_c('h5',{staticClass:"text-xs font-light flex-1 flex items-center"},[_c('span',{staticClass:"block uppercase"},[_vm._v(_vm._s(_vm.__(':something Filter', {something: _vm.__('Month')})))])]),_vm._v(" "),_c('h5',{staticClass:"text-xs font-light self-end"},[(_vm.remainingBalance)?_c('span',{staticClass:"block uppercase"},[_vm._v(_vm._s(_vm.__('Remaining')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between mx-4 mb-4 pb-2 "},[_c('h5',{staticClass:"text-3xl font-hairline flex-1 flex items-center cursor-pointer",on:{"click":function($event){_vm.showDateSelectionMenu = ! _vm.showDateSelectionMenu}}},[_c('span',{staticClass:"block mr-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('svg',{staticClass:"block fill-current h-8 w-8 mt-2 toggle",class:{'reverse': _vm.showDateSelectionMenu},attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0-.75h24v24H0z","fill":"none"}})])]),_vm._v(" "),_c('h5',{staticClass:"text-3xl font-hairline self-end"},[(_vm.remainingBalance)?_c('span',{staticClass:"block"},[_vm._v(_vm._s(_vm._f("yen")(_vm.remainingBalance)))]):_vm._e()])]),_vm._v(" "),(_vm.showDateSelectionMenu)?_c('div',{staticClass:"h-full flex flex-col mx-4"},[(_vm.filteredBy)?_c('a',{staticClass:"text-3xl font-hairline flex items-center no-underline text-grey-dark pb-2 mb-2",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.filterWith(null)}}},[_vm._v("\n                "+_vm._s(_vm.__('All entries'))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.availableMonths),function(month){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredBy !== month),expression:"filteredBy !== month"}],staticClass:"text-3xl font-hairline flex items-center no-underline text-grey-dark pb-2 mb-2",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.filterWith(month)}}},[_vm._v(_vm._s(_vm._f("onlyYearAndMonth")(month)))])})],2):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredDays),function(day,idx){return (! _vm.showDateSelectionMenu)?_c('EntriesOfTheDay',{key:idx,attrs:{"entries":_vm.filteredEntries[day],"day":day}}):_vm._e()})],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(! _vm.hasEntries),expression:"! hasEntries"}],staticClass:"flex flex-col justify-center items-center w-full p-6"},[_c('p',{staticClass:"text-center text-2xl font-light"},[_vm._v(_vm._s(_vm.__('Add your first entry!')))]),_vm._v(" "),_c('a',{staticClass:"flex justify-between items-center bg-expense p-4 mt-8 text-white no-underline",attrs:{"title":_vm.__('Add Entry')},on:{"click":function($event){$event.preventDefault();_vm.$emit('showNewEntryScreen')}}},[_c('svg',{staticClass:"fill-current text-white w-4 h-4",attrs:{"viewBox":"0 0 24 24","preserverAspectRatio":"true","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})]),_vm._v(" "),_c('span',{staticClass:"ml-4 mr-2"},[_vm._v(_vm._s(_vm.__('New Entry')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEntryScreen_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c821c5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEntryScreen_vue__ = __webpack_require__(191);
function injectStyle (ssrContext) {
  __webpack_require__(189)
  __webpack_require__(190)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEntryScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c821c5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEntryScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"flex flex-row justify-between w-full text-xl"},[_c('button',{staticClass:"w-1/2 p-4",class:_vm.form.type === 'expense' ? 'bg-expense text-grey-lightest' : 'bg-grey-light text-grey-dark',attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.form.type = 'expense'}}},[_vm._v("\n            "+_vm._s(_vm.__('Add :entryType', {entryType: _vm.__('expense')}))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"w-1/2 p-4",class:_vm.form.type === 'income' ? 'bg-income text-grey-lightest' : 'bg-grey-light text-grey-dark',attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.form.type = 'income'}}},[_vm._v("\n            "+_vm._s(_vm.__('Add :entryType', {entryType: _vm.__('income')}))+"\n        ")])]),_vm._v(" "),_c('form',{staticClass:"w-full p-6 flex flex-col justify-start items-center",on:{"submit":function($event){$event.preventDefault();_vm.add(_vm.form)}}},[_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-amount"}},[_vm._v("\n                    "+_vm._s(_vm.__('Amount'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"flex items-center bg-grey-lighter text-grey-darker border border-grey-lighter rounded"},[_c('div',{staticClass:"pl-3 text-grey-darkest"},[_vm._v("¥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.amount),expression:"form.amount",modifiers:{"number":true}}],staticClass:"block appearance-none bg-transparent block w-full -ml-4 py-3 pl-6 pr-4",attrs:{"type":"number","step":"0.01","placeholder":_vm.__('Amount'),"id":"grid-amount","autofocus":"","required":""},domProps:{"value":(_vm.form.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "amount", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-category"}},[_vm._v("\n                    "+_vm._s(_vm.__('Category'))+"\n                ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-category","tagPlaceholder":_vm.__('Add New Category'),"selectLabel":_vm.__('Choose Category'),"selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Category'),"options":_vm.allCategories,"taggable":true,"placeholder":_vm.__('Category'),"openDirection":"below"},on:{"tag":_vm.addCategory,"input":_vm.chooseCategory},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-description"}},[_vm._v("\n                    "+_vm._s(_vm.__('Description'))+"\n                ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-description","tagPlaceholder":_vm.__('Add New Description'),"selectLabel":_vm.__('Choose Description'),"selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Description'),"options":_vm.descriptions,"taggable":true,"placeholder":_vm.__('Description'),"openDirection":"below"},on:{"tag":_vm.addDescription,"input":_vm.chooseDescription},model:{value:(_vm.selectedDescription),callback:function ($$v) {_vm.selectedDescription=$$v},expression:"selectedDescription"}})],1)]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-on-date"}},[_vm._v("\n                    "+_vm._s(_vm.__('On Date'))+"\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDate),expression:"selectedDate"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"type":"datetime-local","placeholder":_vm.__('On Date'),"id":"grid-on-date","required":""},domProps:{"value":(_vm.selectedDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedDate=$event.target.value}}})])]),_vm._v(" "),_c('hr',{staticClass:"w-1/3 border-t mb-3"}),_vm._v(" "),_c('button',{staticClass:"w-1/2 bg-expense text-white p-3",attrs:{"type":"submit","disabled":_vm.adding}},[_vm._v("\n            "+_vm._s(_vm.__('Add'))+"\n        ")])]),_vm._v(" "),_c('Loading',{attrs:{"busy":_vm.adding}}),_vm._v(" "),(_vm.error)?_c('Notify',{attrs:{"type":"error","message":_vm.error.message,"show":_vm.error}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-start justify-start relative z-10"},[(_vm.account)?_c('section',{staticClass:"w-full relative z-10 shadow bg-white"},[_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"p-4 flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest"},[_c('img',{staticClass:"rounded-full h-16 w-16 border-2 border-grey-light mr-4",attrs:{"src":("/static/img/account-" + (_vm.account.type) + ".png")}}),_vm._v(" "),_c('div',{staticClass:"flex-1 flex flex-col justify-center items-start"},[_c('span',[_vm._v(_vm._s(_vm.account.name))]),_vm._v(" "),_c('span',{staticClass:"text-sm text-grey-dark"},[_vm._v(_vm._s(_vm.__(_vm.account.type)))])]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[(! _vm.hasEntries && ! _vm.showNewEntryScreen)?_c('a',{staticClass:"block w-6 h-6 cursor-pointer mr-2",attrs:{"aria-label":"Delete Account"},on:{"click":function($event){_vm.remove(_vm.account)}}},[_c('svg',{staticClass:"w-6 h-6 fill-current text-expense opacity-80",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0V0z"}})])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"rotateIn"}},[(! _vm.showNewEntryScreen)?_c('a',{key:"openAdd",staticClass:"block h-6 w-6 cursor-pointer",attrs:{"title":_vm.__('New Entry')},on:{"click":function($event){$event.preventDefault();_vm.showNewEntryScreen = true}}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey hover:text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-9h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2H9a1 1 0 0 1 0-2h2V9a1 1 0 0 1 2 0v2z"}})])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"rotateIn"}},[(_vm.showNewEntryScreen)?_c('a',{key:"closeAdd",staticClass:"block h-8 w-8 cursor-pointer",attrs:{"title":_vm.__('Close')},on:{"click":function($event){$event.preventDefault();_vm.showNewEntryScreen = false}}},[_c('svg',{staticClass:"fill-current h-8 w-8 text-grey hover:text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M4.93 19.07A10 10 0 1 1 19.07 4.93 10 10 0 0 1 4.93 19.07zm1.41-1.41A8 8 0 1 0 17.66 6.34 8 8 0 0 0 6.34 17.66zM13.41 12l1.42 1.41a1 1 0 1 1-1.42 1.42L12 13.4l-1.41 1.42a1 1 0 1 1-1.42-1.42L10.6 12l-1.42-1.41a1 1 0 1 1 1.42-1.42L12 10.6l1.41-1.42a1 1 0 1 1 1.42 1.42L13.4 12z"}})])]):_vm._e()])],1)])])]):_vm._e(),_vm._v(" "),_c('portal-target',{attrs:{"name":"edit-entry"}}),_vm._v(" "),_c('transition',{attrs:{"name":"slideInDownOutUp"}},[(_vm.showNewEntryScreen)?_c('NewEntryScreen',{attrs:{"account":_vm.account},on:{"close":function($event){_vm.showNewEntryScreen = false}}}):_vm._e()],1),_vm._v(" "),(! _vm.showNewEntryScreen)?_c('Entries',{on:{"showNewEntryScreen":function($event){_vm.showNewEntryScreen = true}}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('Notify',{attrs:{"type":"error","message":_vm.error.message,"show":_vm.error},on:{"dismiss":function($event){_vm.error = null}}}):_vm._e(),_vm._v(" "),_c('Loading',{attrs:{"busy":_vm.removing}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAccount_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d67a23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAccount_vue__ = __webpack_require__(194);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d67a23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-start justify-start relative z-10"},[_c('section',{staticClass:"w-full relative z-10 shadow bg-white"},[_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"p-4 flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest"},[_c('h2',{staticClass:"text-2xl text-grey-dark font-hairline flex-1 flex items-center"},[_vm._v(_vm._s(_vm.__('Add Account')))])])])]),_vm._v(" "),_c('div',{staticClass:"container mx-auto"},[_c('form',{staticClass:"w-full p-6 flex flex-col justify-start items-center",on:{"submit":function($event){$event.preventDefault();_vm.add(_vm.form)}}},[_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-name"}},[_vm._v("\n                        "+_vm._s(_vm.__('Account Name'))+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"type":"text","id":"grid-name","required":"","autofocus":"","placeholder":_vm.__('Account Name')},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-type"}},[_vm._v("\n                        "+_vm._s(_vm.__('Account Type'))+"\n                    ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.type),expression:"form.type"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"id":"grid-type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.types),function(type){return _c('option',{domProps:{"value":type}},[_vm._v(_vm._s(_vm.__(type)))])}))]),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-6 pt-3 text-grey-darker"},[_c('svg',{staticClass:"fill-current h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"}})])])]),_vm._v(" "),_c('hr',{staticClass:"w-1/3 border-t mb-3"}),_vm._v(" "),_c('button',{staticClass:"w-1/2 bg-expense text-white p-3",attrs:{"type":"submit","disabled":_vm.adding}},[_vm._v("\n                "+_vm._s(_vm.__('Add'))+"\n\n            ")])])]),_vm._v(" "),(_vm.error)?_c('Notify',{attrs:{"type":"error","message":_vm.error.message,"show":_vm.error},on:{"dismiss":function($event){_vm.error = null}}}):_vm._e(),_vm._v(" "),_c('Loading',{attrs:{"busy":_vm.adding}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEntry_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4653682_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEntry_vue__ = __webpack_require__(198);
function injectStyle (ssrContext) {
  __webpack_require__(196)
  __webpack_require__(197)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4653682_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideInDown"}},[_c('div',{staticClass:"bg-bubble flex flex-col items-start justify-start relative z-10"},[_c('section',{staticClass:"w-full relative z-10 shadow bg-white"},[_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"p-4 flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest"},[_c('div',{staticClass:"flex-1 flex justify-start items-center"},[_c('h2',{staticClass:"text-2xl text-grey-dark font-hairline flex-1 flex items-center px-4"},[_vm._v(_vm._s(_vm.__('Add :entryType', {entryType: _vm.__(_vm.form.type)})))])])])])]),_vm._v(" "),_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"flex flex-row justify-between w-full text-xl"},[_c('button',{staticClass:"w-1/2 p-4",class:_vm.form.type === 'expense' ? 'bg-expense text-grey-lightest' : 'bg-grey-light text-grey-dark',attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.form.type = 'expense'}}},[_vm._v("\n                    "+_vm._s(_vm.__('expense'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"w-1/2 p-4",class:_vm.form.type === 'income' ? 'bg-income text-grey-lightest' : 'bg-grey-light text-grey-dark',attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.form.type = 'income'}}},[_vm._v("\n                    "+_vm._s(_vm.__('income'))+"\n            ")])]),_vm._v(" "),_c('form',{staticClass:"w-full p-6 flex flex-col justify-start items-center",on:{"submit":function($event){$event.preventDefault();_vm.add(_vm.form)}}},[_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-account"}},[_vm._v("\n                            "+_vm._s(_vm.__('Account'))+"\n                    ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-account","selectLabel":_vm.__('Choose Account'),"label":"name","selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Account'),"options":_vm.accounts,"allow-empty":false,"track-by":"name","placeholder":_vm.__('Account'),"openDirection":"below"},on:{"input":_vm.chooseAccount},model:{value:(_vm.selectedAccount),callback:function ($$v) {_vm.selectedAccount=$$v},expression:"selectedAccount"}})],1)]),_vm._v(" "),_c('hr',{staticClass:"w-1/3 border-t mb-3"}),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-amount"}},[_vm._v("\n                            "+_vm._s(_vm.__('Amount'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"flex items-center bg-grey-lighter text-grey-darker border border-grey-lighter rounded"},[_c('div',{staticClass:"pl-3 text-grey-darkest"},[_vm._v("¥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.amount),expression:"form.amount",modifiers:{"number":true}}],staticClass:"block appearance-none bg-transparent block w-full -ml-4 py-3 pl-6 pr-4",attrs:{"type":"number","step":"0.01","placeholder":_vm.__('Amount'),"id":"grid-amount","autofocus":"","required":""},domProps:{"value":(_vm.form.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "amount", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-category"}},[_vm._v("\n                            "+_vm._s(_vm.__('Category'))+"\n                    ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-category","tagPlaceholder":_vm.__('Add New Category'),"selectLabel":_vm.__('Choose Category'),"selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Category'),"options":_vm.allCategories,"taggable":true,"placeholder":_vm.__('Category'),"openDirection":"below"},on:{"tag":_vm.addCategory,"input":_vm.chooseCategory},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-description"}},[_vm._v("\n                            "+_vm._s(_vm.__('Description'))+"\n                    ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-description","tagPlaceholder":_vm.__('Add New Description'),"selectLabel":_vm.__('Choose Description'),"selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Description'),"options":_vm.descriptions,"taggable":true,"placeholder":_vm.__('Description'),"openDirection":"below"},on:{"tag":_vm.addDescription,"input":_vm.chooseDescription},model:{value:(_vm.selectedDescription),callback:function ($$v) {_vm.selectedDescription=$$v},expression:"selectedDescription"}})],1)]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-on-date"}},[_vm._v("\n                            "+_vm._s(_vm.__('On Date'))+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDate),expression:"selectedDate"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"type":"datetime-local","placeholder":_vm.__('On Date'),"id":"grid-on-date","required":""},domProps:{"value":(_vm.selectedDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedDate=$event.target.value}}})])]),_vm._v(" "),_c('hr',{staticClass:"w-1/3 border-t mb-3"}),_vm._v(" "),_c('button',{staticClass:"w-1/2 bg-expense text-white p-3",attrs:{"type":"submit","disabled":_vm.busy}},[_vm._v("\n                    "+_vm._s(_vm.__('Add'))+"\n            ")])]),_vm._v(" "),_c('Loading',{attrs:{"busy":_vm.busy}}),_vm._v(" "),(_vm.error)?_c('Notify',{attrs:{"type":"error","message":_vm.error.message,"show":_vm.error},on:{"dismiss":function($event){_vm.error = null}}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditEntry_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869c6c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEntry_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(200)
  __webpack_require__(201)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869c6c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideInDownOutUp"}},[(_vm.entry)?_c('div',{staticClass:"bg-bubble flex flex-col items-start justify-start relative z-10"},[_c('section',{staticClass:"w-full relative z-10 shadow bg-white"},[_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"p-4 flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest"},[_c('div',{staticClass:"flex-1 flex justify-start items-center"},[_c('a',{staticClass:"block h-6 w-6 cursor-pointer",attrs:{"title":_vm.__('Close')},on:{"click":function($event){$event.preventDefault();_vm.$router.back()}}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey hover:text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M4.93 19.07A10 10 0 1 1 19.07 4.93 10 10 0 0 1 4.93 19.07zm1.41-1.41A8 8 0 1 0 17.66 6.34 8 8 0 0 0 6.34 17.66zM13.41 12l1.42 1.41a1 1 0 1 1-1.42 1.42L12 13.4l-1.41 1.42a1 1 0 1 1-1.42-1.42L10.6 12l-1.42-1.41a1 1 0 1 1 1.42-1.42L12 10.6l1.41-1.42a1 1 0 1 1 1.42 1.42L13.4 12z"}})])]),_vm._v(" "),_c('h2',{staticClass:"text-2xl text-grey-dark font-hairline flex-1 flex items-center px-4"},[_vm._v(_vm._s(_vm.__('Edit :entryType', {entryType: _vm.__(_vm.form.type)})))])]),_vm._v(" "),_c('button',{staticClass:"w-6 h-6 flex",attrs:{"type":"button","aria-label":"Delete"},on:{"click":function($event){_vm.remove(_vm.entry)}}},[_c('svg',{staticClass:"w-6 h-6 fill-current text-expense opacity-80",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0V0z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"flex flex-row justify-between w-full text-xl"},[_c('button',{staticClass:"w-1/2 p-4",class:_vm.form.type === 'expense' ? 'bg-expense text-grey-lightest' : 'bg-grey-light text-grey-dark',attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.form.type = 'expense'}}},[_vm._v("\n                    "+_vm._s(_vm.__('expense'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"w-1/2 p-4",class:_vm.form.type === 'income' ? 'bg-income text-grey-lightest' : 'bg-grey-light text-grey-dark',attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.form.type = 'income'}}},[_vm._v("\n                    "+_vm._s(_vm.__('income'))+"\n            ")])]),_vm._v(" "),_c('form',{staticClass:"w-full p-6 flex flex-col justify-start items-center",on:{"submit":function($event){$event.preventDefault();_vm.update(_vm.entry, _vm.form)}}},[_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-account"}},[_vm._v("\n                            "+_vm._s(_vm.__('Account'))+"\n                    ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-account","selectLabel":_vm.__('Choose Account'),"label":"name","selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Account'),"options":_vm.accounts,"allow-empty":false,"track-by":"name","placeholder":_vm.__('Account'),"openDirection":"below"},on:{"input":_vm.chooseAccount},model:{value:(_vm.selectedAccount),callback:function ($$v) {_vm.selectedAccount=$$v},expression:"selectedAccount"}})],1)]),_vm._v(" "),_c('hr',{staticClass:"w-1/3 border-t mb-3"}),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-amount"}},[_vm._v("\n                            "+_vm._s(_vm.__('Amount'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"flex items-center bg-grey-lighter text-grey-darker border border-grey-lighter rounded"},[_c('div',{staticClass:"pl-3 text-grey-darkest"},[_vm._v("¥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.amount),expression:"form.amount",modifiers:{"number":true}}],staticClass:"block appearance-none bg-transparent block w-full -ml-4 py-3 pl-6 pr-4",attrs:{"type":"number","step":"0.01","placeholder":_vm.__('Amount'),"id":"grid-amount","autofocus":"","required":""},domProps:{"value":(_vm.form.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "amount", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-category"}},[_vm._v("\n                            "+_vm._s(_vm.__('Category'))+"\n                    ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-category","tagPlaceholder":_vm.__('Add New Category'),"selectLabel":_vm.__('Choose Category'),"selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Category'),"options":_vm.allCategories,"taggable":true,"placeholder":_vm.__('Category'),"openDirection":"below"},on:{"tag":_vm.addCategory,"input":_vm.chooseCategory},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-description"}},[_vm._v("\n                            "+_vm._s(_vm.__('Description'))+"\n                    ")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"grid-description","tagPlaceholder":_vm.__('Add New Description'),"selectLabel":_vm.__('Choose Description'),"selectedLabel":_vm.__('Selected'),"deselectLabel":_vm.__('Remove Description'),"options":_vm.descriptions,"taggable":true,"placeholder":_vm.__('Description'),"openDirection":"below"},on:{"tag":_vm.addDescription,"input":_vm.chooseDescription},model:{value:(_vm.selectedDescription),callback:function ($$v) {_vm.selectedDescription=$$v},expression:"selectedDescription"}})],1)]),_vm._v(" "),_c('div',{staticClass:"w-full flex flex-wrap -mx-3 mb-3 relative"},[_c('div',{staticClass:"w-full px-3"},[_c('label',{staticClass:"block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2",attrs:{"for":"grid-on-date"}},[_vm._v("\n                            "+_vm._s(_vm.__('On Date'))+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDate),expression:"selectedDate"}],staticClass:"block appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3",attrs:{"type":"datetime-local","placeholder":_vm.__('On Date'),"id":"grid-on-date","required":""},domProps:{"value":(_vm.selectedDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedDate=$event.target.value}}})])]),_vm._v(" "),_c('hr',{staticClass:"w-1/3 border-t mb-3"}),_vm._v(" "),_c('button',{staticClass:"w-1/2 bg-expense text-white p-3",attrs:{"type":"submit","disabled":_vm.busy}},[_vm._v("\n                    "+_vm._s(_vm.__('Update'))+"\n            ")])]),_vm._v(" "),_c('Loading',{attrs:{"busy":_vm.busy}}),_vm._v(" "),(_vm.error)?_c('Notify',{attrs:{"type":"error","message":_vm.error.message,"show":_vm.error},on:{"dismiss":function($event){_vm.error = null}}}):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overviews_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1f5946_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overviews_vue__ = __webpack_require__(204);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overviews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1f5946_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overviews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-start justify-start relative z-10"},[_c('section',{staticClass:"w-full p-4 relative z-10 shadow bg-white"},[_c('div',{staticClass:"container mx-auto flex justify-between items-center"},[_c('h2',{staticClass:"text-3xl font-hairline flex-1"},[_vm._v("\n                "+_vm._s(_vm.__('Overview'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"container mx-auto"},[(_vm.accounts.length > 0)?_c('div',[_vm._l((_vm.accounts),function(account,idx){return [_c('div',{staticClass:"p-4 flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest pointer-events-auto cursor-pointer",on:{"click":function($event){_vm.$router.push({name: 'View Overview', params: {accountId: account.id}})}}},[_c('img',{staticClass:"rounded-full h-16 w-16 border-2 border-grey-light mr-4",attrs:{"src":("/static/img/account-" + (account.type) + ".png")}}),_vm._v(" "),_c('div',{staticClass:"flex-1 flex flex-col justify-center items-start"},[_c('h3',{staticClass:"flex items-baseline text-xl font-light"},[_vm._v(_vm._s(account.name))]),_vm._v(" "),_c('p',{staticClass:"text-base text-grey-darker mt-3 font-normal"},[_c('span',{staticClass:"text-income"},[_vm._v(_vm._s(_vm._f("yen")(_vm.totalIncome[account.id])))]),_vm._v(" ・ "),_c('span',{staticClass:"text-expense"},[_vm._v(_vm._s(_vm._f("yen")(_vm.totalExpense[account.id])))])])]),_vm._v(" "),_c('a',{staticClass:"block h-6 w-6 cursor-pointer",attrs:{"title":_vm.__('View Account')}},[_c('svg',{staticClass:"fill-current h-6 w-6 text-grey hover:text-grey-dark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M9.3 8.7a1 1 0 0 1 1.4-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.29-3.3-3.3-3.3z"}})])])]),_vm._v(" "),(_vm.accounts.length - 1 !== idx)?_c('hr',{staticClass:"w-1/3 border-t-2"}):_vm._e()]})],2):_c('div',{staticClass:"p-4"},[_vm._v("\n            "+_vm._s(_vm.__('No accounts to overview yet'))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2477e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__(206);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2477e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-start justify-start relative z-10"},[(_vm.account)?_c('section',{staticClass:"w-full relative z-10 shadow bg-white"},[_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"p-4 flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest"},[_c('img',{staticClass:"rounded-full h-16 w-16 border-2 border-grey-light mr-4",attrs:{"src":("/static/img/account-" + (_vm.account.type) + ".png")}}),_vm._v(" "),_c('div',{staticClass:"flex-1 flex flex-col justify-center items-start"},[_c('span',[_vm._v(_vm._s(_vm.account.name))]),_vm._v(" "),_c('span',{staticClass:"text-sm text-grey-dark"},[_vm._v(_vm._s(_vm.__(_vm.account.type)))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"overflow-hidden w-full mb-8"},[_c('div',{staticClass:"flex flex-row justify-between mx-4 mt-4 mb-2 pb-2 "},[_c('h5',{staticClass:"text-3xl font-hairline flex-1 flex items-center"},[_c('span',{staticClass:"block mr-2"},[_vm._v(_vm._s(_vm.__('Overview')))])])]),_vm._v(" "),_c('div',{staticClass:"entries mb-8"},[_c('div',{staticClass:"flex flex-col items-center"},[_c('div',{staticClass:"flex flex-col justify-center bg-o5-grey-lighter block border-b border-o5-grey-light  px-4 py-3 block w-full"},[_c('div',{staticClass:"flex flex-row items-center relative"},[_c('div',{staticClass:"text-xl flex-1"},[_c('div',{},[_vm._v(_vm._s(_vm.__('Remaining')))])]),_vm._v(" "),_c('h5',{staticClass:"text-2xl font-light",class:'text-' + _vm.remainingType},[_vm._v(_vm._s(_vm._f("yen")(_vm.remainingBalance)))])])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between w-full"},[_c('span',{staticClass:"font-thin text-xl pb-2 px-4 block mt-4"},[_vm._v(_vm._s(_vm.__('Income')))]),_vm._v(" "),_c('span',{staticClass:"font-thin text-2xl pb-2 px-4 block mt-4 text-income"},[_vm._v(_vm._s(_vm._f("yen")(_vm.totalIncome)))])]),_vm._v(" "),_c('div',{staticClass:"entries mb-4"},_vm._l((_vm.groupedEntries.income),function(amount,category){return _c('div',{staticClass:"flex flex-col items-center"},[_c('div',{staticClass:"flex flex-col justify-center bg-o5-grey-lighter block border-b border-o5-grey-light  px-4 py-3 block w-full"},[_c('div',{staticClass:"flex flex-row items-center relative"},[_c('div',{staticClass:"text-sm flex-1"},[_c('div',{},[_vm._v(_vm._s(category))])]),_vm._v(" "),_c('h5',{staticClass:"text-base font-light"},[_vm._v(_vm._s(_vm._f("yen")(amount)))])])])])})),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-between w-full"},[_c('span',{staticClass:"font-thin text-xl pb-2 px-4 block mt-4"},[_vm._v(_vm._s(_vm.__('Expenses')))]),_vm._v(" "),_c('span',{staticClass:"font-thin text-2xl pb-2 px-4 block mt-4 text-expense"},[_vm._v(_vm._s(_vm._f("yen")(_vm.totalExpense)))])]),_vm._v(" "),_c('div',{staticClass:"entries mb-8"},_vm._l((_vm.groupedEntries.expenses),function(amount,category){return _c('div',{staticClass:"flex flex-col items-center"},[_c('div',{staticClass:"flex flex-col justify-center bg-o5-grey-lighter block border-b border-o5-grey-light  px-4 py-3 block w-full"},[_c('div',{staticClass:"flex flex-row items-center relative"},[_c('div',{staticClass:"text-sm flex-1"},[_c('div',{},[_vm._v(_vm._s(category))])]),_vm._v(" "),_c('h5',{staticClass:"text-base font-light"},[_vm._v(_vm._s(_vm._f("yen")(amount)))])])])])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(31);




__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].watch(function (_ref) {
    var language = _ref.language;
    return language;
}, function (toLanguage, fromLanguage) {
    __WEBPACK_IMPORTED_MODULE_1_luxon__["Settings"].defaultLocale = toLanguage;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('date', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromFormat(value, 'yyyy-L-d').toLocaleString({ year: 'numeric', month: 'long', day: 'numeric' });
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('yen', function (value) {
    return new Intl.NumberFormat(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.language, {
        style: 'currency',
        currency: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.currency
    }).format(value);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('onlyYearAndMonth', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(value.toISOString()).toLocaleString({ year: 'numeric', month: 'long' });
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __ */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translations__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);






function _(key, replace) {
    var defaultLang = this ? this.$options.language : 'en';
    var lang = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['language'];

    var i18n = __WEBPACK_IMPORTED_MODULE_0__translations__["a" /* default */].hasOwnProperty(lang) ? __WEBPACK_IMPORTED_MODULE_0__translations__["a" /* default */][lang] : __WEBPACK_IMPORTED_MODULE_0__translations__["a" /* default */][defaultLang];

    var translation = i18n.hasOwnProperty(key) ? i18n[key] : key;

    Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["forEach"])(replace, function (value, key) {
        translation = translation.replace(':' + key, value);
    });

    return translation;
}

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
    language: 'en',
    methods: {
        __: function __(key, replace) {
            return _(key, replace);
        }
    }
});

/* unused harmony default export */ var _unused_webpack_default_export = (_);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translations_en__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translations_ja__ = __webpack_require__(212);



/* harmony default export */ __webpack_exports__["a"] = ({
    en: __WEBPACK_IMPORTED_MODULE_0__translations_en__["a" /* default */],
    ja: __WEBPACK_IMPORTED_MODULE_1__translations_ja__["a" /* default */]
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    ':something Filter': ':something Filter',
    'expense': 'Expense',
    'income': 'Income',
    'Expense': 'Expense',
    'Income': 'Income',
    'Category': 'Category',
    'Description': 'Description',
    'Sign in with Google': 'Sign in with Google',
    'credit_card': 'Credit Card',
    'debit_card': 'Debit Card',
    'savings': 'Savings Account',
    'cash': 'Cash on Hand'
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Amount': '金額',
    'Close': 'キャンセル',
    'Go To Login': 'ログインに戻る',
    'Update': '更新',
    'expense': '支出',
    'income': '収入',
    'Expense': '支出',
    'Income': '収入',
    'expenses': '支出',
    'Expenses': '支出',
    'Category': '勘定科目',
    'Description': '備考',
    'Remaining': '残高',
    'All entries': '月別',
    'Edit :entryType': ':entryTypeの編集',
    'Add': '記録',
    'Add :entryType': ':entryTypeの記録',
    'Filter': 'フィルター',
    ':something Filter': ':somethingフィルター',
    'Month': '月',
    'Start App': 'アプリ起動',
    'Add New Category': '勘定科目の追加',
    'Add New Description': '備考の追加',
    'Choose Category': '勘定科目を選択',
    'Choose Description': '備考を選択',
    'Remove Category': '勘定科目を取消',
    'Remove Description': '備考を取消',
    'Selected': '選択済',
    'Overview': '損益表',
    'Total': '合計',
    'Sign in with Google': 'Googleログイン',
    'Loading': '少々お待ちしてください',
    'Add your first entry!': 'まずは今収入を記録しましょう！',
    'New Entry': '記録',
    'English': '英語',
    'Japanese': '日本語',
    'Settings': '設定',
    'credit_card': 'クレジットカード',
    'debit_card': 'デビットカード',
    'savings': '貯金口座',
    'cash': '現金',
    'On Date': '日付',
    'Language': '言語',
    'Accounts': 'アカウント',
    'Account': 'アカウント',
    'Account Type': 'アカウント型',
    'Account Name': 'アカウント名',
    'Add Account': 'アカウント追加',
    'Default Account': 'メインアカウント',
    'Currency': '通貨',
    'No accounts to overview yet': '先にアカウント作ってください。',
    'No accounts yet': 'アカウントありません。'
});

/***/ })
],[87]);


// WEBPACK FOOTER //
// static/js/app.668f5934f0ac93e74f23.js